(function (globalScope) {
  'use strict';

  const browserRegistryKey = '__DRBO_SAVINGS_CALCULATOR__';
  const existingBrowserRegistry = globalScope && globalScope[browserRegistryKey];
  if (typeof module === 'undefined' && existingBrowserRegistry) {
    if (globalScope.document) existingBrowserRegistry.initWithin(globalScope.document);
    return;
  }

  const instances = new WeakMap();

  const TRANSLATIONS = Object.freeze({
    de: Object.freeze({
      storageClass: "{1} kWh Speicherklasse",
      gridOutput: "Bis {1} W Ausgangsleistung im Netzbetrieb",
      systemBasis: "Passende Systembasis",
      expandCapacity: "Für Deinen Verbrauch wird die Speicherkapazität im Speicher-Finder auf etwa {1} kWh erweitert.",
      startingCapacity: "Diese Leistungsklasse startet mit {1} kWh Speicherkapazität.",
      capacityOrientation: "{1} kWh passen als erste Orientierung zu Deinem angegebenen Jahresverbrauch.",
      retrofitComponents: "Bei der AC-seitigen Nachrüstung müssen vorhandener Wechselrichter, Smart Meter und Messkonzept einbezogen werden.",
      modulesExcluded: "Die gewählten {1} PV-Module sind nicht enthalten und werden separat ausgelegt.",
      modulesModelOnly: "Die Modulzahl dient der Ertragsrechnung; PV-Module sind nicht enthalten.",
      confirmContents: "Lieferumfang und Anschluss werden im Speicher-Finder bestätigt.",
      topologySystem: "Für {1} Module plant der Rechner mindestens {2} geeignete Hauptgeräte ein. Zusammen bieten sie bis zu {3} W Gesamtausgangsleistung des Systems.",
      multiSystem: "{1} geeignete Hauptgeräte ergeben zusammen bis zu {2} W Gesamtausgangsleistung des Systems.",
      mainUnits: "{1} Hauptgeräte · technische Systemplanung erforderlich",
      viewFamily: "{1} ansehen",
      totalOutput: "{1} W Gesamtausgangsleistung des Systems",
      distributeModules: "{1} Module technisch auf {2} Hauptgeräte verteilen",
      checkConnection: "Anschluss, Phasen, Schutzkonzept und Netzanbindung prüfen",
      targetCapacity: "Gezeigt wird die {1}-kWh-Systembasis; Deine Zielgröße von etwa {2} kWh wird im Speicher-Finder ergänzt.",
      capacityBasis: "Die Speicherklasse orientiert sich an Deinem angegebenen Jahresverbrauch.",
      check800: "Gewählte 800-W-Klasse technisch abgleichen",
      confirmOutput: "Ausgangsleistung im Speicher-Finder bestätigen",
      retrofitCopy: "AC CORE ist der Produktausgangspunkt für die AC-seitige Nachrüstung einer bestehenden PV-Anlage. Vorhandener Wechselrichter, Smart Meter, Messkonzept und Anschluss müssen fachlich geprüft werden. {1}",
      checkRetrofit: "AC-seitige Nachrüstung technisch prüfen",
      viewAcCore: "AC CORE ansehen",
      addTarget: "Zielgröße im Speicher-Finder ergänzen",
      checkExisting: "Bestandsanlage und Anschluss prüfen",
      unsurePlanCopy: "{1} dient hier als konkreter Vergleichs- und Produktausgangspunkt. Systemweg, Ausgangsleistung, PV-Anbindung und Lieferumfang werden im Speicher-Finder passend zu Deinem Projekt bestätigt.",
      confirmSystem: "Systemweg im Speicher-Finder bestätigen",
      viewBasis: "Systembasis ansehen",
      systemOpen: "Systemaufbau und Lieferumfang noch offen",
      unsureOutputCopy: "{1} wird als Produktbasis gezeigt, nicht als endgültige Leistungsempfehlung. Ob 800 W oder bis zu 2.400 W zu Deinem Anschluss und Deinen Verbrauchern passen, klärst Du im Speicher-Finder.",
      outputConfirm: "Ausgangsleistung noch zu bestätigen",
      outputOpen: "Ausgangsleistung noch offen",
      addModules: "PV-Module passend ergänzen",
      checkSystem: "Anschluss und Systemaufbau prüfen",
      modulePower: "{1} Module · {2} Wp",
      checkWiring: "Verschaltung für {1} Wp technisch prüfen",
      addModuleSelection: "{1} passend ergänzen",
      customPvCopy: "{1} ist die passende Speicherbasis ohne PV-Module. Die von Dir gewählten {2} Module sind im gezeigten Angebot nicht enthalten und werden im Speicher-Finder technisch passend ergänzt.",
      modulesSeparate: "PV-Module werden separat zugeordnet",
      moduleCount: "{1} Module",
      checkPvCopy: "{1} ist die passende Systembasis ohne PV-Module. Die berechneten {2} sind im Angebot nicht enthalten; Verschaltung und PV-Eingangsgrenzen müssen vor der Bestellung geprüft werden.",
      checkPvDesign: "PV-Auslegung separat prüfen",
      checkModulePower: "{1} · {2} Wp technisch prüfen",
      selectionMatch: "Passend zu Deiner Auswahl",
      pvBundleCopy: "Komplettpaket für Deine Auswahl mit vier 460-Wp-Modulen. Verbindlich sind Preis und Lieferumfang auf der Produktseite.",
      coreBundleCopy: "Speicherpaket ohne PV-Module. Die gewählte Modulzahl fließt in die Modellrechnung ein; Preis und Lieferumfang stehen verbindlich auf der Produktseite.",
      bundlePower: "4 × 460 Wp im Paket",
      noModules: "Ohne PV-Module",
      viewBundle: "Paket ansehen",
      viewSystem: "System ansehen",
      bundleModules: "4 × 460 Wp PV-Module im Paket",
      basisNoModules: "Systembasis ohne PV-Module",
      multiSummary: "Systembasis mit {1} Hauptgeräten. Technische Systemplanung erforderlich.{2}",
      retrofitSummary: "AC CORE als Ausgangspunkt für die AC-seitige Nachrüstung. Die Bestandsanlage muss technisch geprüft werden.",
      planSummary: "Produktbasis zum Vergleich. Systemaufbau und Lieferumfang sind noch offen.",
      outputSummary: "Produktbasis zur Orientierung. Die passende Ausgangsleistung muss noch geklärt werden.",
      customSummary: "Speicherbasis ohne PV-Module. Die gewählten {1} Module müssen separat ausgelegt und ergänzt werden.",
      pvCheckSummary: "Systembasis ohne PV-Module. Die PV-Anbindung muss vor der Bestellung geprüft werden.",
      pvSummary: "PV-Paket mit vier 460-Wp-Modulen.",
      coreSummary: "Speicherpaket ohne PV-Module.",
      customTitle: "Dein System individuell planen",
      highConsumption: "Bei mehr als 6.000 kWh Jahresverbrauch ordnen wir nicht pauschal ein Paket zu. Deine Modellrechnung bleibt sichtbar. Im Speicher-Finder kannst Du Verbrauch, Speicherbedarf und Anschluss für eine passende Systemplanung genauer eingrenzen.",
      check800Title: "800-W-Auswahl zuerst technisch klären",
      check800Copy: "Für die AC-seitige Nachrüstung ist die gewählte 800-W-Klasse keine eindeutige Produktzuordnung. Prüfe im Speicher-Finder zuerst Wechselrichter, Smart Meter, Messkonzept und Anschluss.",
      existingTitle: "Bestehende PV zuerst technisch zuordnen",
      existingCopy: "Bei einer AC-seitigen Nachrüstung müssen Wechselrichter, Smart Meter, Messkonzept und Anschluss gemeinsam geprüft werden. Der Speicher-Finder hilft Dir, AC CORE als passende Systembasis einzuordnen.",
      seriesTitle: "Mit wenigen Fragen zur passenden 500-Serie",
      seriesCopy: "Wenn Systemaufbau oder Lieferumfang noch offen sind, grenzt der Speicher-Finder Kapazität, Leistung und Komponenten verlässlich ein.",
      outputGuidance: "Die passende Ausgangsleistung hängt von Anschluss und gleichzeitig genutzten Verbrauchern ab. Prüfe diese Auswahl im Speicher-Finder.",
      checkFamilyModules: "{1} für {2} prüfen",
      moduleGuidance: "{1} mit je 460 Wp ergeben {2} Wp. Die stündliche Modellrechnung berücksichtigt diese Gesamtleistung, Deinen Jahresverbrauch und die gewählte Ausgangsleistung. Verschaltung, PV-Eingangsgrenzen und Lieferumfang müssen passend zum konkreten System geprüft werden.",
      configurePv: "{1} mit passendem PV-Paket zusammenstellen",
      twoModules: "Die direkt zugeordneten Komplettpakete enthalten vier 460-Wp-Module. Für zwei Module stellst Du den passenden Lieferumfang im Speicher-Finder zusammen.",
      missingTitle: "Passendes 500-System derzeit nicht direkt zugeordnet",
      missingCopy: "Für Deine Auswahl fehlt aktuell eine verfügbare, eindeutig zugeordnete Produktvariante. Im Speicher-Finder kannst Du die Konfiguration weiter prüfen.",
      configurationTitle: "Konfiguration technisch eingrenzen",
      configurationCopy: "Für diese Auswahl sollten Systemaufbau und Komponenten vor der Bestellung geprüft werden.",
      year: " Jahr",
      years: " Jahre",
      paybackSingle: "ca. {1} Jahre",
      paybackRange: "ca. {1}–{2} Jahre",
      selectionComplete: "Auswahl vollständig",
      stepProgress: "Schritt {1} von {2}",
      confirmedProgress: "{1} von {2} Angaben bestätigt",
      resultKicker: "Deine Modellrechnung",
      alternative: "Alternative mit {1} W ansehen",
      completeInvestment: "Für die vollständige neue Anlage",
      storageInvestment: "Für die zusätzliche Speicherinvestition",
      investment: "Berücksichtigte Investition: {1}, davon zusätzliche Kosten: {2}.",
      cashflow: "Nettoersparnis im ungünstigeren Szenario, Jahr 1 / 2 / 3: {1}.",
      source: "Quelle {1}",
      moduleNote: "Wähle 2 bis 24 Module mit je 460 Wp. Wir berechnen den Solarertrag und die Selbstnutzung für Deine Modulzahl und Ausgangsleistung.",
      north: "Nord",
      northEast: "Nordost",
      east: "Ost",
      southEast: "Südost",
      south: "Süd",
      southWest: "Südwest",
      west: "West",
      northWest: "Nordwest",
      duoNote: "Produkthinweis: Für {1} Module zeigt der Rechner eine Duo-Systembasis mit zwei Hauptgeräten zur technischen Prüfung.",
      trioNote: "Produkthinweis: Für {1} Module wird mindestens eine Trio-Systembasis mit drei Hauptgeräten vorgesehen.",
      planPv: "Speicher mit Solarmodulen",
      planCore: "Speicher ohne Solarmodule",
      planRetrofit: "Speicher nachrüsten",
      planUnsure: "Noch unsicher",
      planPvDescription: "Du suchst einen Speicher mit Solarmodulen für eine neue Anlage.",
      planCoreDescription: "Du suchst einen Speicher ohne Solarmodule. Die Module planst Du separat.",
      planRetrofitDescription: "Du hast bereits eine PV-Anlage und möchtest einen Speicher ergänzen.",
      planUnsureDescription: "Du möchtest erst prüfen, welches System zu Deinem Zuhause passt.",
      degrees: "{1} Grad",
      notSelected: "Nicht gewählt",
      continueModules: "Mit {1} Modulen weiter",
      continueOutput: "Weiter zur Ausgangsleistung",
      calculateConsumption: "Mit {1} kWh berechnen",
      output800: "Die Rechnung berücksichtigt 800 W als gemeinsame Grenze für Solarstrom und Speicherabgabe an den Haushalt.",
      outputUnchanged: "Gegenüber {1} W bleibt die gerundete Ersparnis gleich. Das stündliche Haushaltsprofil nutzt die zusätzliche Leistung hier kaum. Kurze Verbrauchsspitzen einzelner Geräte sind nicht abgebildet.",
      outputIncrease: "Gegenüber {1} W sind das im Modell rund {2} € mehr Ersparnis pro Jahr. Mehr Leistung erzeugt keinen zusätzlichen Solarstrom, kann aber mehr davon zur gleichen Zeit nutzbar machen.",
      outputIncluded: "{1} W Ausgangsleistung berücksichtigt",
      savingsEquation: "{1} kWh × {2} = rund {3} €/Jahr",
      storageReference: "Speicher-Referenz: {1} kWh nutzbar; nicht die Kapazität der Produktempfehlung",
      modelBasis: "PVGIS 5.3 · Frankfurt am Main · 2021–2023 · stündliche Rechnung mit dynamischem H0-Referenzprofil · {1}",
      modelScope: "Referenzmodell, keine produktspezifische Berechnung. Annahmen: 2,4 kW Ladegrenze und 90 % Speicher-Rundlaufwirkungsgrad. Standort, Verschattung und Dein tatsächlicher Tagesverbrauch können das Ergebnis deutlich verändern.",
      liveUpdate: "Modellrechnung aktualisiert: rund {1} Euro mögliche Stromkostenersparnis pro Jahr.",
      excludedSentence: " PV-Module sind nicht enthalten.",
      pvSuffix: " PV-Paket",
      series: "SunEnergyXT 500-Serie",
      outputGuidanceTitle: "800 W oder 2.400 W technisch einordnen",
      annualConsumption: "{1} kWh/Jahr",
      preset: " · voreingestellt",
      verifiedYears: "ca. {1}{2}",
    }),
    en: Object.freeze({
      storageClass: "{1} kWh storage class",
      gridOutput: "Up to {1} W output in grid-connected operation",
      systemBasis: "Suitable system base",
      expandCapacity: "For your consumption, storage capacity is expanded to around {1} kWh in the storage finder.",
      startingCapacity: "This output class starts with {1} kWh of storage capacity.",
      capacityOrientation: "{1} kWh provides an initial guide based on your stated annual consumption.",
      retrofitComponents: "An AC-coupled retrofit must take the existing inverter, Smart Meter and metering arrangement into account.",
      modulesExcluded: "The {1} selected PV modules are not included and are designed separately.",
      modulesModelOnly: "The module count is used to calculate yield; PV modules are not included.",
      confirmContents: "Package contents and connection are confirmed in the storage finder.",
      topologySystem: "For {1} modules, the calculator allows for at least {2} suitable main units. Together, they provide up to {3} W total system output.",
      multiSystem: "{1} suitable main units together provide up to {2} W total system output.",
      mainUnits: "{1} main units · technical system design required",
      viewFamily: "View {1}",
      totalOutput: "{1} W total system output",
      distributeModules: "Check how to distribute {1} modules across {2} main units",
      checkConnection: "Check connection, phases, protection design and grid connection",
      targetCapacity: "The {1} kWh system base is shown; your target of around {2} kWh is added in the storage finder.",
      capacityBasis: "The storage class is based on your stated annual consumption.",
      check800: "Check the technical suitability of the selected 800 W class",
      confirmOutput: "Confirm output in the storage finder",
      retrofitCopy: "AC CORE is the product starting point for an AC-coupled storage retrofit to an existing PV system. The existing inverter, Smart Meter, metering arrangement and connection require professional assessment. {1}",
      checkRetrofit: "Check the technical requirements for an AC-coupled retrofit",
      viewAcCore: "View AC CORE",
      addTarget: "Add the target capacity in the storage finder",
      checkExisting: "Check the existing system and connection",
      unsurePlanCopy: "{1} is shown as a concrete starting point for product comparison. System type, output, PV connection and package contents are confirmed for your project in the storage finder.",
      confirmSystem: "Confirm the system type in the storage finder",
      viewBasis: "View system base",
      systemOpen: "System configuration and package contents still to be determined",
      unsureOutputCopy: "{1} is shown as a product base, not a final output recommendation. Use the storage finder to check whether 800 W or up to 2,400 W suits your connection and appliances.",
      outputConfirm: "Output still to be confirmed",
      outputOpen: "Output still to be determined",
      addModules: "Add suitable PV modules",
      checkSystem: "Check connection and system configuration",
      modulePower: "{1} modules · {2} Wp",
      checkWiring: "Check the wiring design for {1} Wp",
      addModuleSelection: "Add a suitable configuration of {1}",
      customPvCopy: "{1} is the suitable storage base without PV modules. The {2} modules you selected are not included in the offer shown; a technically suitable configuration is added in the storage finder.",
      modulesSeparate: "PV modules are selected separately",
      moduleCount: "{1} modules",
      checkPvCopy: "{1} is the suitable system base without PV modules. The {2} used in the calculation are not included in the offer; wiring and PV input limits must be checked before ordering.",
      checkPvDesign: "Check PV design separately",
      checkModulePower: "Check technical suitability: {1} · {2} Wp",
      selectionMatch: "Matches your selection",
      pvBundleCopy: "Complete package for your selection with four 460 Wp modules. The price and package contents on the product page are binding.",
      coreBundleCopy: "Storage package without PV modules. The selected module count is used in the model calculation; the product page states the binding price and package contents.",
      bundlePower: "4 × 460 Wp included",
      noModules: "Without PV modules",
      viewBundle: "View package",
      viewSystem: "View system",
      bundleModules: "4 × 460 Wp PV modules included",
      basisNoModules: "System base without PV modules",
      multiSummary: "System base with {1} main units. Technical system design required.{2}",
      retrofitSummary: "AC CORE as a starting point for an AC-coupled retrofit. The existing system requires a technical assessment.",
      planSummary: "Product base for comparison. System configuration and package contents are still to be determined.",
      outputSummary: "Product base for initial guidance. The suitable output still needs to be determined.",
      customSummary: "Storage base without PV modules. The {1} selected modules need to be designed and added separately.",
      pvCheckSummary: "System base without PV modules. The PV connection must be checked before ordering.",
      pvSummary: "PV package with four 460 Wp modules.",
      coreSummary: "Storage package without PV modules.",
      customTitle: "Plan your system individually",
      highConsumption: "For annual consumption above 6,000 kWh, we do not assign a standard package. Your model calculation remains visible. Use the storage finder to refine consumption, storage needs and connection requirements for a suitable system design.",
      check800Title: "Check the technical suitability of 800 W first",
      check800Copy: "For an AC-coupled retrofit, the selected 800 W class does not identify a specific suitable product. First check the inverter, Smart Meter, metering arrangement and connection in the storage finder.",
      existingTitle: "Assess the existing PV system first",
      existingCopy: "For an AC-coupled retrofit, the inverter, Smart Meter, metering arrangement and connection must be assessed together. The storage finder helps you assess AC CORE as a suitable system base.",
      seriesTitle: "Find the right 500 series with a few questions",
      seriesCopy: "If system configuration or package contents are still undecided, the storage finder helps narrow down capacity, output and components.",
      outputGuidance: "The suitable output depends on the connection and appliances used at the same time. Check this selection in the storage finder.",
      checkFamilyModules: "Check {1} for {2}",
      moduleGuidance: "{1} rated at 460 Wp each provide {2} Wp in total. The hourly model calculation accounts for this total power, your annual consumption and the selected output. Wiring, PV input limits and package contents must be checked for the specific system.",
      configurePv: "Configure {1} with a suitable PV package",
      twoModules: "The directly matched complete packages contain four 460 Wp modules. For two modules, configure the suitable package contents in the storage finder.",
      missingTitle: "No suitable 500 system directly matched at present",
      missingCopy: "No available product variant is currently clearly matched to your selection. You can check the configuration further in the storage finder.",
      configurationTitle: "Clarify the technical configuration",
      configurationCopy: "For this selection, system configuration and components should be checked before ordering.",
      year: " year",
      years: " years",
      paybackSingle: "approx. {1} years",
      paybackRange: "approx. {1}–{2} years",
      selectionComplete: "Selection complete",
      stepProgress: "Step {1} of {2}",
      confirmedProgress: "{1} of {2} inputs confirmed",
      resultKicker: "Your model calculation",
      alternative: "View alternative with {1} W",
      completeInvestment: "For the complete new system",
      storageInvestment: "For the additional storage investment",
      investment: "Investment included: {1}, of which additional costs: {2}.",
      cashflow: "Net savings in the adverse scenario, year 1 / 2 / 3: {1}.",
      source: "Source {1}",
      moduleNote: "Choose 2 to 24 modules rated at 460 Wp each. We calculate solar yield and self-consumption for your module count and output.",
      north: "North",
      northEast: "Northeast",
      east: "East",
      southEast: "Southeast",
      south: "South",
      southWest: "Southwest",
      west: "West",
      northWest: "Northwest",
      duoNote: "Product note: for {1} modules, the calculator shows a Duo system base with two main units for technical assessment.",
      trioNote: "Product note: for {1} modules, at least a Trio system base with three main units is planned.",
      planPv: "Storage with solar modules",
      planCore: "Storage without solar modules",
      planRetrofit: "Add storage to an existing system",
      planUnsure: "Not sure yet",
      planPvDescription: "You are looking for storage with solar modules for a new system.",
      planCoreDescription: "You are looking for storage without solar modules. You plan the modules separately.",
      planRetrofitDescription: "You already have a PV system and want to add storage.",
      planUnsureDescription: "You want to check which system suits your home first.",
      degrees: "{1} degrees",
      notSelected: "Not selected",
      continueModules: "Continue with {1} modules",
      continueOutput: "Continue to output",
      calculateConsumption: "Calculate with {1} kWh",
      output800: "The calculation uses 800 W as the combined limit for solar power and battery discharge to the household.",
      outputUnchanged: "Compared with {1} W, the rounded savings remain the same. The hourly household profile makes little use of the additional output here. Brief consumption peaks from individual appliances are not represented.",
      outputIncrease: "Compared with {1} W, the model shows around €{2} more savings per year. More output does not generate extra solar power, but can make more of it usable at the same time.",
      outputIncluded: "{1} W output included in the calculation",
      savingsEquation: "{1} kWh × {2} = around €{3}/year",
      storageReference: "Storage reference: {1} kWh usable; not the capacity of the recommended product",
      modelBasis: "PVGIS 5.3 · Frankfurt am Main, Germany · 2021–2023 · hourly calculation with a dynamic H0 reference profile · {1}",
      modelScope: "Reference model, not a product-specific calculation. Assumptions: 2.4 kW charging limit and 90% battery round-trip efficiency. Location, shading and your actual daily consumption can significantly change the result.",
      liveUpdate: "Model calculation updated: around {1} euros in potential electricity cost savings per year.",
      excludedSentence: " PV modules are not included.",
      pvSuffix: " PV package",
      series: "SunEnergyXT 500 series",
      outputGuidanceTitle: "Assess the technical suitability of 800 W or 2,400 W",
      annualConsumption: "{1} kWh/year",
      preset: " · preset",
      verifiedYears: "approx. {1}{2}",
    }),
    nl: Object.freeze({
      storageClass: "Opslagklasse van {1} kWh",
      gridOutput: "Tot {1} W uitgangsvermogen bij netgekoppeld gebruik",
      systemBasis: "Passende systeembasis",
      expandCapacity: "Voor je verbruik wordt de opslagcapaciteit in de opslagkeuzehulp uitgebreid tot ongeveer {1} kWh.",
      startingCapacity: "Deze vermogensklasse begint met {1} kWh opslagcapaciteit.",
      capacityOrientation: "{1} kWh is een eerste richtwaarde op basis van je opgegeven jaarverbruik.",
      retrofitComponents: "Bij een AC-gekoppelde uitbreiding moeten de bestaande omvormer, Smart Meter en meetopstelling worden meegenomen.",
      modulesExcluded: "De {1} gekozen zonnepanelen zijn niet inbegrepen en worden apart in het ontwerp opgenomen.",
      modulesModelOnly: "Het aantal panelen wordt gebruikt voor de opbrengstberekening; zonnepanelen zijn niet inbegrepen.",
      confirmContents: "De inhoud van het pakket en de aansluiting worden bevestigd in de opslagkeuzehulp.",
      topologySystem: "Voor {1} panelen rekent de calculator met minimaal {2} geschikte hoofdeenheden. Samen leveren deze tot {3} W totaal uitgangsvermogen van het systeem.",
      multiSystem: "{1} geschikte hoofdeenheden leveren samen tot {2} W totaal uitgangsvermogen van het systeem.",
      mainUnits: "{1} hoofdeenheden · technisch systeemontwerp vereist",
      viewFamily: "Bekijk {1}",
      totalOutput: "{1} W totaal uitgangsvermogen van het systeem",
      distributeModules: "Controleer de verdeling van {1} panelen over {2} hoofdeenheden",
      checkConnection: "Controleer aansluiting, fasen, beveiligingsconcept en netaansluiting",
      targetCapacity: "De systeembasis van {1} kWh wordt getoond; je doelcapaciteit van ongeveer {2} kWh wordt in de opslagkeuzehulp aangevuld.",
      capacityBasis: "De opslagklasse is gebaseerd op je opgegeven jaarverbruik.",
      check800: "Controleer of de gekozen 800 W-klasse technisch geschikt is",
      confirmOutput: "Bevestig het uitgangsvermogen in de opslagkeuzehulp",
      retrofitCopy: "AC CORE is het productuitgangspunt voor een AC-gekoppelde opslaguitbreiding van een bestaande PV-installatie. De bestaande omvormer, Smart Meter, meetopstelling en aansluiting moeten vakkundig worden beoordeeld. {1}",
      checkRetrofit: "Controleer de technische eisen voor een AC-gekoppelde uitbreiding",
      viewAcCore: "Bekijk AC CORE",
      addTarget: "Vul de doelcapaciteit aan in de opslagkeuzehulp",
      checkExisting: "Controleer de bestaande installatie en aansluiting",
      unsurePlanCopy: "{1} wordt getoond als concreet uitgangspunt om producten te vergelijken. Het systeemtype, uitgangsvermogen, de PV-aansluiting en pakketinhoud worden in de opslagkeuzehulp afgestemd op je project.",
      confirmSystem: "Bevestig het systeemtype in de opslagkeuzehulp",
      viewBasis: "Bekijk de systeembasis",
      systemOpen: "Systeemopbouw en pakketinhoud nog te bepalen",
      unsureOutputCopy: "{1} wordt getoond als productbasis, niet als definitief vermogensadvies. Controleer in de opslagkeuzehulp of 800 W of tot 2.400 W past bij je aansluiting en apparaten.",
      outputConfirm: "Uitgangsvermogen nog te bevestigen",
      outputOpen: "Uitgangsvermogen nog te bepalen",
      addModules: "Voeg geschikte zonnepanelen toe",
      checkSystem: "Controleer aansluiting en systeemopbouw",
      modulePower: "{1} panelen · {2} Wp",
      checkWiring: "Controleer het elektrische schakelplan voor {1} Wp",
      addModuleSelection: "Voeg een passende configuratie van {1} toe",
      customPvCopy: "{1} is de passende opslagbasis zonder zonnepanelen. De {2} gekozen panelen zijn niet inbegrepen in het getoonde aanbod; een technisch passende configuratie wordt toegevoegd in de opslagkeuzehulp.",
      modulesSeparate: "Zonnepanelen worden apart geselecteerd",
      moduleCount: "{1} panelen",
      checkPvCopy: "{1} is de passende systeembasis zonder zonnepanelen. De {2} uit de berekening zijn niet inbegrepen in het aanbod; het schakelplan en de PV-ingangsgrenzen moeten vóór bestelling worden gecontroleerd.",
      checkPvDesign: "Controleer het PV-ontwerp apart",
      checkModulePower: "Controleer de technische geschiktheid: {1} · {2} Wp",
      selectionMatch: "Passend bij je keuze",
      pvBundleCopy: "Compleet pakket voor je keuze met vier panelen van 460 Wp. De prijs en pakketinhoud op de productpagina zijn bepalend.",
      coreBundleCopy: "Opslagpakket zonder zonnepanelen. Het gekozen aantal panelen wordt gebruikt in de modelberekening; de productpagina vermeldt de geldende prijs en pakketinhoud.",
      bundlePower: "4 × 460 Wp inbegrepen",
      noModules: "Zonder zonnepanelen",
      viewBundle: "Bekijk het pakket",
      viewSystem: "Bekijk het systeem",
      bundleModules: "4 × 460 Wp zonnepanelen inbegrepen",
      basisNoModules: "Systeembasis zonder zonnepanelen",
      multiSummary: "Systeembasis met {1} hoofdeenheden. Technisch systeemontwerp vereist.{2}",
      retrofitSummary: "AC CORE als uitgangspunt voor een AC-gekoppelde uitbreiding. De bestaande installatie moet technisch worden beoordeeld.",
      planSummary: "Productbasis ter vergelijking. Systeemopbouw en pakketinhoud zijn nog te bepalen.",
      outputSummary: "Productbasis als eerste oriëntatie. Het passende uitgangsvermogen moet nog worden bepaald.",
      customSummary: "Opslagbasis zonder zonnepanelen. De {1} gekozen panelen moeten apart worden ontworpen en toegevoegd.",
      pvCheckSummary: "Systeembasis zonder zonnepanelen. De PV-aansluiting moet vóór bestelling worden gecontroleerd.",
      pvSummary: "PV-pakket met vier panelen van 460 Wp.",
      coreSummary: "Opslagpakket zonder zonnepanelen.",
      customTitle: "Plan je systeem op maat",
      highConsumption: "Bij een jaarverbruik boven 6.000 kWh wijzen we niet automatisch een standaardpakket toe. Je modelberekening blijft zichtbaar. In de opslagkeuzehulp kun je verbruik, opslagbehoefte en aansluiting verder afstemmen voor een passend systeemontwerp.",
      check800Title: "Controleer eerst of 800 W technisch geschikt is",
      check800Copy: "Bij een AC-gekoppelde uitbreiding leidt de gekozen 800 W-klasse niet tot een eenduidige productkeuze. Controleer eerst de omvormer, Smart Meter, meetopstelling en aansluiting in de opslagkeuzehulp.",
      existingTitle: "Beoordeel eerst de bestaande PV-installatie",
      existingCopy: "Bij een AC-gekoppelde uitbreiding moeten omvormer, Smart Meter, meetopstelling en aansluiting samen worden beoordeeld. De opslagkeuzehulp helpt je bepalen of AC CORE een passende systeembasis is.",
      seriesTitle: "Vind de passende 500-serie met een paar vragen",
      seriesCopy: "Als de systeemopbouw of pakketinhoud nog niet vaststaat, helpt de opslagkeuzehulp je de capaciteit, het vermogen en de componenten te bepalen.",
      outputGuidance: "Het passende uitgangsvermogen hangt af van de aansluiting en de apparaten die je tegelijk gebruikt. Controleer deze keuze in de opslagkeuzehulp.",
      checkFamilyModules: "Controleer {1} voor {2}",
      moduleGuidance: "{1} van elk 460 Wp leveren samen {2} Wp. De uurlijkse modelberekening houdt rekening met dit totale vermogen, je jaarverbruik en het gekozen uitgangsvermogen. Het schakelplan, de PV-ingangsgrenzen en de pakketinhoud moeten voor het specifieke systeem worden gecontroleerd.",
      configurePv: "Stel {1} samen met een passend PV-pakket",
      twoModules: "De direct toegewezen complete pakketten bevatten vier panelen van 460 Wp. Voor twee panelen stel je de passende pakketinhoud samen in de opslagkeuzehulp.",
      missingTitle: "Momenteel geen passend 500-systeem direct toegewezen",
      missingCopy: "Er is momenteel geen beschikbare productvariant die eenduidig bij je keuze past. Je kunt de configuratie verder controleren in de opslagkeuzehulp.",
      configurationTitle: "Bepaal de technische configuratie",
      configurationCopy: "Voor deze keuze moeten de systeemopbouw en componenten vóór bestelling worden gecontroleerd.",
      year: " jaar",
      years: " jaar",
      paybackSingle: "ca. {1} jaar",
      paybackRange: "ca. {1}–{2} jaar",
      selectionComplete: "Keuze voltooid",
      stepProgress: "Stap {1} van {2}",
      confirmedProgress: "{1} van {2} gegevens bevestigd",
      resultKicker: "Je modelberekening",
      alternative: "Bekijk een alternatief met {1} W",
      completeInvestment: "Voor de volledige nieuwe installatie",
      storageInvestment: "Voor de aanvullende investering in opslag",
      investment: "Meegerekende investering: {1}, waarvan aanvullende kosten: {2}.",
      cashflow: "Netto besparing in het ongunstige scenario, jaar 1 / 2 / 3: {1}.",
      source: "Bron {1}",
      moduleNote: "Kies 2 tot 24 panelen van elk 460 Wp. We berekenen de zonneopbrengst en het eigen verbruik voor je aantal panelen en uitgangsvermogen.",
      north: "Noord",
      northEast: "Noordoost",
      east: "Oost",
      southEast: "Zuidoost",
      south: "Zuid",
      southWest: "Zuidwest",
      west: "West",
      northWest: "Noordwest",
      duoNote: "Productopmerking: voor {1} panelen toont de calculator een Duo-systeembasis met twee hoofdeenheden voor technische beoordeling.",
      trioNote: "Productopmerking: voor {1} panelen wordt uitgegaan van minimaal een Trio-systeembasis met drie hoofdeenheden.",
      planPv: "Opslag met zonnepanelen",
      planCore: "Opslag zonder zonnepanelen",
      planRetrofit: "Opslag toevoegen aan een bestaande installatie",
      planUnsure: "Nog niet zeker",
      planPvDescription: "Je zoekt opslag met zonnepanelen voor een nieuwe installatie.",
      planCoreDescription: "Je zoekt opslag zonder zonnepanelen. Je plant de panelen apart.",
      planRetrofitDescription: "Je hebt al een PV-installatie en wilt opslag toevoegen.",
      planUnsureDescription: "Je wilt eerst kijken welk systeem bij je woning past.",
      degrees: "{1} graden",
      notSelected: "Niet gekozen",
      continueModules: "Verder met {1} panelen",
      continueOutput: "Verder naar uitgangsvermogen",
      calculateConsumption: "Bereken met {1} kWh",
      output800: "De berekening gebruikt 800 W als gezamenlijke grens voor zonnestroom en batterijontlading naar het huishouden.",
      outputUnchanged: "Vergeleken met {1} W blijft de afgeronde besparing gelijk. Het uurlijkse huishoudprofiel benut het extra vermogen hier nauwelijks. Korte verbruikspieken van afzonderlijke apparaten zijn niet meegenomen.",
      outputIncrease: "Vergeleken met {1} W levert dit volgens het model ongeveer € {2} extra besparing per jaar op. Meer vermogen wekt geen extra zonnestroom op, maar kan ervoor zorgen dat er meer tegelijk bruikbaar is.",
      outputIncluded: "{1} W uitgangsvermogen meegerekend",
      savingsEquation: "{1} kWh × {2} = ongeveer € {3}/jaar",
      storageReference: "Opslagreferentie: {1} kWh bruikbaar; niet de capaciteit van het aanbevolen product",
      modelBasis: "PVGIS 5.3 · Frankfurt am Main, Duitsland · 2021–2023 · uurlijkse berekening met een dynamisch H0-referentieprofiel · {1}",
      modelScope: "Referentiemodel, geen productspecifieke berekening. Aannames: laadgrens van 2,4 kW en 90 % laad-ontlaadrendement van de batterij. Locatie, schaduw en je werkelijke dagelijkse verbruik kunnen het resultaat aanzienlijk veranderen.",
      liveUpdate: "Modelberekening bijgewerkt: ongeveer {1} euro mogelijke besparing op stroomkosten per jaar.",
      excludedSentence: " Zonnepanelen zijn niet inbegrepen.",
      pvSuffix: " PV-pakket",
      series: "SunEnergyXT 500-serie",
      outputGuidanceTitle: "Beoordeel de technische geschiktheid van 800 W of 2.400 W",
      annualConsumption: "{1} kWh/jaar",
      preset: " · vooraf ingesteld",
      verifiedYears: "ca. {1}{2}",
    }),
  });

  function createLocalization(config = {}) {
    const documentLocale = globalScope.document && globalScope.document.documentElement && globalScope.document.documentElement.lang;
    const requestedLocale = String(documentLocale || config.locale || 'de-DE').replace(/_/g, '-');
    const requestedLanguage = requestedLocale.toLowerCase().split('-')[0];
    const language = Object.prototype.hasOwnProperty.call(TRANSLATIONS, requestedLanguage) ? requestedLanguage : 'en';
    const defaultLocale = { de: 'de-DE', en: 'en-GB', nl: 'nl-NL' }[language];
    let locale = defaultLocale;
    try {
      if (language === requestedLanguage) locale = Intl.getCanonicalLocales(requestedLocale)[0] || defaultLocale;
    } catch {}
    return {
      language,
      locale,
      t(key, values = []) {
        const template = TRANSLATIONS[language][key];
        if (typeof template !== 'string') throw new Error('invalid-translation-key');
        return template.replace(/\{(\d+)\}/g, (placeholder, index) => String(values[Number(index) - 1]));
      },
      formatNumber: (value) => formatNumber(value, locale),
      formatDecimal: (value) => formatDecimal(value, locale),
      formatEuroPerKwh: (value) => formatEuroPerKwh(value, locale),
    };
  }

  function localizedUrl(url, routesRootUrl) {
    if (typeof url !== 'string' || typeof routesRootUrl !== 'string') return url;
    const match = url.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?((?:products|pages)\/.*)$/i);
    if (!match || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(routesRootUrl)) return url;
    return routesRootUrl.replace(/\/$/, '') + '/' + match[1];
  }

  function isProductUrl(url) {
    return typeof url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#]+(?:[/?#]|$)/i.test(url);
  }


  const DIRECTIONS = Object.freeze(['N', 'NO', 'O', 'SO', 'S', 'SW', 'W', 'NW']);
  const TILTS = Object.freeze([0, 10, 20, 30, 40, 50, 60, 70, 80, 90]);
  const MODULE_COUNTS = Object.freeze([2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24]);
  const PLAN_OPTIONS = Object.freeze(['new-pv', 'core', 'retrofit', 'unsure']);
  const OUTPUT_OPTIONS = Object.freeze([800, 2400, 4800, 7200]);
  const REQUIRED_STEP_COUNT = 3;
  const BUILDING_TYPES = Object.freeze(['apartment', 'house']);
  const MODEL_VERSION = 'PVGIS53-H0-2021-2023-v4-consumption-hourly';
  const CONSUMPTION_MIN = 1000;
  const CONSUMPTION_MAX = 10000;
  const CONSUMPTION_STEP = 100;
  const CONSUMPTION_COUNT = (CONSUMPTION_MAX - CONSUMPTION_MIN) / CONSUMPTION_STEP + 1;
  const LOOKUP_COUNT = DIRECTIONS.length * TILTS.length * MODULE_COUNTS.length * OUTPUT_OPTIONS.length * 2 * CONSUMPTION_COUNT;
  const EXPECTED_SYSTEMS = Object.freeze({
    2: Object.freeze({ moduleCount: 2, pvWp: 920, usableStorageKwh: 2 }),
    4: Object.freeze({ moduleCount: 4, pvWp: 1840, usableStorageKwh: 4.8 }),
    6: Object.freeze({ moduleCount: 6, pvWp: 2760, usableStorageKwh: 9.6 }),
    8: Object.freeze({ moduleCount: 8, pvWp: 3680, usableStorageKwh: null }),
    10: Object.freeze({ moduleCount: 10, pvWp: 4600, usableStorageKwh: null }),
    12: Object.freeze({ moduleCount: 12, pvWp: 5520, usableStorageKwh: null }),
    14: Object.freeze({ moduleCount: 14, pvWp: 6440, usableStorageKwh: null }),
    16: Object.freeze({ moduleCount: 16, pvWp: 7360, usableStorageKwh: null }),
    18: Object.freeze({ moduleCount: 18, pvWp: 8280, usableStorageKwh: null }),
    20: Object.freeze({ moduleCount: 20, pvWp: 9200, usableStorageKwh: null }),
    22: Object.freeze({ moduleCount: 22, pvWp: 10120, usableStorageKwh: null }),
    24: Object.freeze({ moduleCount: 24, pvWp: 11040, usableStorageKwh: null }),
  });
  const EXPECTED_HOUSEHOLDS = Object.freeze({
    apartment: Object.freeze([1200, 1900, 2400, 2600, 3100]),
    house: Object.freeze([1800, 2700, 3500, 3800, 4500]),
  });
  const hourlyModel = typeof module !== 'undefined' && module.exports
    ? require('./drbo-savings-model.js')
    : globalScope.DRBOSavingsModel;
  const PVGIS_ANNUAL_KWH_PER_KWP = Object.fromEntries(DIRECTIONS.map((direction, index) => [direction, hourlyModel && hourlyModel.annualYields[index]]));
  let selfUseKwhLookup;

  function finiteNumber(value) {
    if (value === null || value === '' || typeof value === 'boolean') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function roundTo(value, step) {
    return Math.round(value / step) * step;
  }

  function getSelfUseLookup() {
    if (selfUseKwhLookup) return selfUseKwhLookup;
    if (!hourlyModel || hourlyModel.version !== MODEL_VERSION || hourlyModel.encoding !== 'consumption-delta-varint' || hourlyModel.consumptionMin !== CONSUMPTION_MIN || hourlyModel.consumptionMax !== CONSUMPTION_MAX || hourlyModel.consumptionStep !== CONSUMPTION_STEP) throw new Error('invalid-model-data');
    let bytes;
    if (typeof Buffer !== 'undefined') {
      bytes = Uint8Array.from(Buffer.from(hourlyModel.selfUseBase64, 'base64'));
    } else {
      const binary = globalScope.atob(hourlyModel.selfUseBase64);
      bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    }
    const decoded = new Uint16Array(LOOKUP_COUNT);
    let byteIndex = 0;
    let previousValue = 0;
    for (let index = 0; index < decoded.length; index += 1) {
      if (index % CONSUMPTION_COUNT === 0) previousValue = 0;
      let delta = 0;
      let shift = 0;
      let nextByte;
      do {
        if (byteIndex >= bytes.length || shift > 14) throw new Error('invalid-model-data');
        nextByte = bytes[byteIndex++];
        delta += (nextByte & 127) * (2 ** shift);
        shift += 7;
      } while (nextByte & 128);
      const value = previousValue + delta;
      const consumption = CONSUMPTION_MIN + (index % CONSUMPTION_COUNT) * CONSUMPTION_STEP;
      if (value > consumption) throw new Error('invalid-model-data');
      decoded[index] = value;
      previousValue = value;
    }
    if (byteIndex !== bytes.length) throw new Error('invalid-model-data');
    selfUseKwhLookup = decoded;
    return selfUseKwhLookup;
  }

  function getSpecificYield(direction, tilt) {
    const values = PVGIS_ANNUAL_KWH_PER_KWP[direction];
    if (!values) throw new Error('invalid-orientation');
    const tiltIndex = TILTS.indexOf(Number(tilt));
    if (tiltIndex === -1) throw new Error('invalid-tilt');
    return values[tiltIndex];
  }

  function getSystem(config, moduleCount) {
    const key = String(moduleCount);
    const system = config.systems && config.systems[key];
    const expected = EXPECTED_SYSTEMS[key];
    if (!system || !expected) throw new Error('invalid-system');
    const parsedModuleCount = finiteNumber(system.moduleCount);
    const pvWp = finiteNumber(system.pvWp);
    const usableStorageKwh = finiteNumber(system.usableStorageKwh);
    const hasExpectedStorageCapacity = expected.usableStorageKwh !== null;
    if (
      parsedModuleCount !== expected.moduleCount ||
      pvWp !== expected.pvWp ||
      (hasExpectedStorageCapacity && usableStorageKwh !== expected.usableStorageKwh) ||
      (!hasExpectedStorageCapacity && system.usableStorageKwh !== null)
    ) {
      throw new Error('invalid-system');
    }
    return { moduleCount: parsedModuleCount, pvWp, usableStorageKwh };
  }

  function getHouseholdConsumption(config, buildingType, householdSize) {
    const buildingIndex = BUILDING_TYPES.indexOf(buildingType);
    const sizeIndex = Number(householdSize) - 1;
    const household = config.households && config.households[buildingType];
    const consumptionKwh = household && finiteNumber(household[String(householdSize)]);
    const expected = EXPECTED_HOUSEHOLDS[buildingType] && EXPECTED_HOUSEHOLDS[buildingType][sizeIndex];
    if (buildingIndex === -1 || sizeIndex < 0 || sizeIndex > 4 || consumptionKwh !== expected) {
      throw new Error('invalid-household');
    }
    return consumptionKwh;
  }

  function getModeledSelfUse(input) {
    const directionIndex = DIRECTIONS.indexOf(input.direction);
    const tiltIndex = TILTS.indexOf(Number(input.tilt));
    const systemIndex = MODULE_COUNTS.indexOf(Number(input.moduleCount));
    const outputIndex = OUTPUT_OPTIONS.indexOf(Number(input.outputW));
    const consumptionIndex = (Number(input.consumptionKwh) - CONSUMPTION_MIN) / CONSUMPTION_STEP;
    const storageIndex = input.storageEnabled === true ? 1 : 0;
    if ([directionIndex, tiltIndex, systemIndex, outputIndex].includes(-1) || !Number.isInteger(consumptionIndex) || consumptionIndex < 0 || consumptionIndex >= CONSUMPTION_COUNT) {
      throw new Error('invalid-model-selection');
    }
    const index = (((((directionIndex * TILTS.length + tiltIndex) * MODULE_COUNTS.length + systemIndex) * OUTPUT_OPTIONS.length + outputIndex) * 2 + storageIndex) * CONSUMPTION_COUNT) + consumptionIndex;
    return getSelfUseLookup()[index];
  }

  function hasValidModelConfig(config) {
    try {
      MODULE_COUNTS.forEach((moduleCount) => getSystem(config, moduleCount));
      BUILDING_TYPES.forEach((buildingType) => {
        [1, 2, 3, 4, 5].forEach((size) => getHouseholdConsumption(config, buildingType, size));
      });
      const electricityPriceCents = finiteNumber(config.electricityPriceCents);
      return Boolean(
        [MODEL_VERSION, 'PVGIS53-H0-2021-2023-v3-output-hourly', 'PVGIS53-H0-2021-2023-v2-extended'].includes(config.modelVersion) &&
        electricityPriceCents !== null &&
        electricityPriceCents >= 10 &&
        electricityPriceCents <= 80 &&
        getSelfUseLookup().length === LOOKUP_COUNT
      );
    } catch (error) {
      return false;
    }
  }

  function calculateEstimate(input, config) {
    if (!input || !hasValidModelConfig(config)) throw new Error('invalid-model-config');
    const outputW = input.outputW === undefined ? 800 : finiteNumber(input.outputW);
    if (!OUTPUT_OPTIONS.includes(outputW)) throw new Error('invalid-output');
    const system = getSystem(config, input.moduleCount);
    const householdSize = input.householdSize === undefined ? null : Number(input.householdSize);
    const consumptionKwh = input.consumptionKwh === undefined
      ? getHouseholdConsumption(config, input.buildingType, householdSize)
      : finiteNumber(input.consumptionKwh);
    if (consumptionKwh === null || consumptionKwh < CONSUMPTION_MIN || consumptionKwh > CONSUMPTION_MAX || (consumptionKwh - CONSUMPTION_MIN) % CONSUMPTION_STEP !== 0) throw new Error('invalid-consumption');
    const specificYieldKwhPerKwp = getSpecificYield(input.direction, Number(input.tilt));
    const configuredElectricityPriceCents = finiteNumber(config.electricityPriceCents);
    const inputElectricityPriceCents = finiteNumber(input.electricityPriceCents);
    const electricityPriceCents = inputElectricityPriceCents === null
      ? configuredElectricityPriceCents
      : inputElectricityPriceCents;
    if (electricityPriceCents === null || electricityPriceCents < 10 || electricityPriceCents > 80) {
      throw new Error('invalid-electricity-price');
    }
    const storageEnabled = input.storageEnabled === true;
    const generationRaw = (system.pvWp / 1000) * specificYieldKwhPerKwp;
    const selfUsedRaw = Math.min(generationRaw, consumptionKwh, getModeledSelfUse({ ...input, consumptionKwh, outputW, storageEnabled }));
    const storageReferenceKwh = storageEnabled
      ? (system.usableStorageKwh === null ? EXPECTED_SYSTEMS[6].usableStorageKwh : system.usableStorageKwh)
      : 0;
    const generationKwh = Math.max(0, roundTo(generationRaw, 10));
    const selfUsedKwh = Math.max(0, Math.min(generationKwh, consumptionKwh, roundTo(selfUsedRaw, 1)));
    const savingsEuro = Math.max(0, roundTo(selfUsedKwh * (electricityPriceCents / 100), 5));
    const gridReductionPercent = clamp(roundTo((selfUsedRaw / consumptionKwh) * 100, 1), 0, 100);
    const selfConsumptionPercent = clamp(roundTo((selfUsedRaw / generationRaw) * 100, 1), 0, 100);

    return {
      mode: 'estimate',
      modelVersion: MODEL_VERSION,
      moduleCount: system.moduleCount,
      outputW,
      pvWp: system.pvWp,
      usableStorageKwh: storageEnabled ? system.usableStorageKwh : 0,
      storageReferenceKwh,
      buildingType: input.buildingType,
      householdSize,
      consumptionKwh,
      direction: input.direction,
      tilt: Number(input.tilt),
      storageEnabled,
      specificYieldKwhPerKwp,
      generationKwh,
      selfUsedKwh,
      savingsEuro,
      gridReductionPercent,
      selfConsumptionPercent,
      electricityPriceCents,
    };
  }
  function isValidCatalog(catalog) {
    return Boolean(
      catalog &&
      catalog.eligible === true &&
      catalog.storefrontPublished === true &&
      catalog.available === true &&
      finiteNumber(catalog.productId) !== null &&
      typeof catalog.title === 'string' && catalog.title.trim() &&
      typeof catalog.url === 'string' && isProductUrl(catalog.url) &&
      Array.isArray(catalog.variants) && catalog.variants.length > 0
    );
  }

  function availableVariants(catalog) {
    if (!isValidCatalog(catalog)) return [];
    return catalog.variants.filter((variant) => Boolean(
      variant &&
      variant.available === true &&
      finiteNumber(variant.variantId) !== null &&
      typeof variant.url === 'string' && isProductUrl(variant.url) &&
      finiteNumber(variant.priceMinor) !== null && variant.priceMinor > 0
    ));
  }

  function capacityClassForConsumption(consumptionKwh) {
    const consumption = finiteNumber(consumptionKwh);
    if (consumption === null) return null;
    if (consumption < 2500) return 5;
    if (consumption < 4000) return 10;
    if (consumption <= 6000) return 15;
    return null;
  }

  function isValidRecommendationEntry(entry) {
    const family = entry && entry.family;
    const bundleType = entry && entry.bundleType;
    const outputW = finiteNumber(entry && entry.outputW);
    const is500Series = ['500', '500_pro'].includes(family) && ['core', 'pv'].includes(bundleType) && [800, 2400].includes(outputW);
    const isAcCore = family === 'ac_core' && bundleType === 'ac' && outputW === 2400;
    const isDuo = ['500_pro_duo', 'ac_core_duo'].includes(family) && ['core', 'ac'].includes(bundleType) && outputW === 4800 && finiteNumber(entry.capacityKwh) === 10;
    const isTrio = ['500_pro_trio', 'ac_core_trio'].includes(family) && ['core', 'ac'].includes(bundleType) && outputW === 7200 && finiteNumber(entry.capacityKwh) === 15;
    return Boolean(
      entry &&
      typeof entry.routeId === 'string' && entry.routeId &&
      (is500Series || isAcCore || isDuo || isTrio) &&
      [5, 10, 15].includes(finiteNumber(entry.capacityKwh)) &&
      isValidCatalog(entry.catalog) &&
      availableVariants(entry.catalog).length > 0
    );
  }

  function formatNumber(value, locale = 'de-DE') {
    return Number(value).toLocaleString(locale, { maximumFractionDigits: 0 });
  }

  function formatDecimal(value, locale = 'de-DE') {
    return Number(value).toLocaleString(locale, { maximumFractionDigits: 1 });
  }

  function formatCurrencyMinor(value, locale = 'de-DE', currencyCode = 'EUR') {
    const priceMinor = finiteNumber(value);
    if (priceMinor === null || typeof currencyCode !== 'string' || !/^[A-Z]{3}$/.test(currencyCode)) return '';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(priceMinor / 100);
  }

  function recommendationDisplayTitle(entry, config = {}) {
    const { t, formatNumber } = createLocalization(config);
    const familyNames = {
      '500': 'SunEnergyXT 500',
      '500_pro': 'SunEnergyXT 500 PRO',
      ac_core: 'SunEnergyXT 500 PRO AC CORE',
      '500_pro_duo': 'SunEnergyXT 500 PRO Duo',
      '500_pro_trio': 'SunEnergyXT 500 PRO Trio',
      ac_core_duo: 'SunEnergyXT 500 PRO AC CORE Duo',
      ac_core_trio: 'SunEnergyXT 500 PRO AC CORE Trio',
    };
    const familyName = familyNames[entry.family];
    const capacityKwh = finiteNumber(entry.capacityKwh);
    if (!familyName || capacityKwh === null) return String(entry.catalog.title || entry.fallbackTitle || '').trim();
    return familyName + ' · ' + formatNumber(capacityKwh) + ' kWh' + (entry.bundleType === 'pv' ? t('pvSuffix') : '');
  }

  function recommendationPresentation(entry, result, selection, decision, config = {}) {
    const { t, formatNumber } = createLocalization(config);
    const capacityKwh = Number(entry.capacityKwh);
    const outputW = Number(entry.outputW);
    const familyNames = {
      '500': 'SunEnergyXT 500',
      '500_pro': 'SunEnergyXT 500 PRO',
      ac_core: 'SunEnergyXT 500 PRO AC CORE',
      '500_pro_duo': 'SunEnergyXT 500 PRO Duo',
      '500_pro_trio': 'SunEnergyXT 500 PRO Trio',
      ac_core_duo: 'SunEnergyXT 500 PRO AC CORE Duo',
      ac_core_trio: 'SunEnergyXT 500 PRO AC CORE Trio',
    };
    const familyName = familyNames[entry.family] || t('series');
    const capacityReason = t('storageClass', [capacityKwh]);
    const outputReason = t('gridOutput', [formatNumber(outputW)]);
    const guidedKicker = t('systemBasis');

    if (['500_pro_duo', '500_pro_trio', 'ac_core_duo', 'ac_core_trio'].includes(entry.family)) {
      const mainUnitCount = outputW / 2400;
      const targetCapacityKwh = Number(decision.targetCapacityKwh || capacityClassForConsumption(result.consumptionKwh));
      const capacityCopy = targetCapacityKwh > capacityKwh
        ? t('expandCapacity', [targetCapacityKwh])
        : targetCapacityKwh < capacityKwh
          ? t('startingCapacity', [capacityKwh])
          : t('capacityOrientation', [capacityKwh]);
      const projectCopy = selection.plan === 'retrofit'
        ? t('retrofitComponents')
        : selection.plan === 'new-pv'
          ? t('modulesExcluded', [result.moduleCount])
          : selection.plan === 'core'
            ? t('modulesModelOnly')
            : t('confirmContents');
      const systemCopy = decision.reason === 'module-topology'
        ? t('topologySystem', [result.moduleCount, mainUnitCount, formatNumber(outputW)])
        : t('multiSystem', [mainUnitCount, formatNumber(outputW)]);
      return {
        kicker: guidedKicker,
        copy: systemCopy + ' ' + capacityCopy + ' ' + projectCopy,
        bundleLabel: t('mainUnits', [mainUnitCount]),
        ctaLabel: t('viewFamily', [familyName.replace('SunEnergyXT ', '')]),
        reasons: [capacityReason, t('totalOutput', [formatNumber(outputW)]), decision.reason === 'module-topology' ? t('distributeModules', [result.moduleCount, mainUnitCount]) : t('checkConnection')],
      };
    }

    if (decision.reason === 'retrofit') {
      const targetCapacityKwh = Number(decision.targetCapacityKwh);
      const capacityCopy = targetCapacityKwh > capacityKwh
        ? t('targetCapacity', [capacityKwh, targetCapacityKwh])
        : t('capacityBasis');
      const outputCheck = Number(selection.outputW) === 800
        ? t('check800')
        : selection.outputW === 'unsure'
          ? t('confirmOutput')
          : outputReason;
      return {
        kicker: guidedKicker,
        copy: t('retrofitCopy', [capacityCopy]),
        bundleLabel: t('checkRetrofit'),
        ctaLabel: t('viewAcCore'),
        reasons: [capacityReason, outputCheck, targetCapacityKwh > capacityKwh ? t('addTarget') : t('checkExisting')],
      };
    }

    if (decision.reason === 'plan-unsure') {
      return {
        kicker: guidedKicker,
        copy: t('unsurePlanCopy', [familyName]),
        bundleLabel: t('confirmSystem'),
        ctaLabel: t('viewBasis'),
        reasons: [capacityReason, outputReason, t('systemOpen')],
      };
    }

    if (decision.reason === 'output-unsure') {
      return {
        kicker: guidedKicker,
        copy: t('unsureOutputCopy', [familyName]),
        bundleLabel: t('outputConfirm'),
        ctaLabel: t('viewBasis'),
        reasons: [capacityReason, t('outputOpen'), selection.plan === 'new-pv' ? t('addModules') : t('checkSystem')],
      };
    }

    if (decision.reason === 'pv-custom') {
      const moduleLabel = t('modulePower', [result.moduleCount, formatNumber(result.pvWp)]);
      const pvCheck = result.pvWp > 2500
        ? t('checkWiring', [formatNumber(result.pvWp)])
        : t('addModuleSelection', [moduleLabel]);
      return {
        kicker: guidedKicker,
        copy: t('customPvCopy', [familyName, result.moduleCount]),
        bundleLabel: t('modulesSeparate'),
        ctaLabel: t('viewBasis'),
        reasons: [capacityReason, outputReason, pvCheck],
      };
    }

    if (decision.reason === 'pv-check') {
      const moduleLabel = t('moduleCount', [result.moduleCount]);
      return {
        kicker: guidedKicker,
        copy: t('checkPvCopy', [familyName, moduleLabel]),
        bundleLabel: t('checkPvDesign'),
        ctaLabel: t('viewBasis'),
        reasons: [capacityReason, outputReason, t('checkModulePower', [moduleLabel, formatNumber(result.pvWp)])],
      };
    }

    const isPvBundle = entry.bundleType === 'pv';
    return {
      kicker: createLocalization(config).language === 'de' ? String(entry.badge || t('selectionMatch')) : t('selectionMatch'),
      copy: isPvBundle
        ? t('pvBundleCopy')
        : t('coreBundleCopy'),
      bundleLabel: isPvBundle ? t('bundlePower') : t('noModules'),
      ctaLabel: isPvBundle ? t('viewBundle') : t('viewSystem'),
      reasons: [capacityReason, outputReason, isPvBundle ? t('bundleModules') : t('basisNoModules')],
    };
  }

  function recommendationSummary(entry, result, selection, decision, config = {}) {
    const { t, formatNumber } = createLocalization(config);
    if (['500_pro_duo', '500_pro_trio', 'ac_core_duo', 'ac_core_trio'].includes(entry.family)) {
      return t('multiSummary', [Number(entry.outputW) / 2400, ['new-pv', 'core'].includes(selection.plan) ? t('excludedSentence') : '']);
    }
    if (decision.reason === 'retrofit') return t('retrofitSummary');
    if (decision.reason === 'plan-unsure') return t('planSummary');
    if (decision.reason === 'output-unsure') return t('outputSummary');
    if (decision.reason === 'pv-custom') return t('customSummary', [result.moduleCount]);
    if (decision.reason === 'pv-check') return t('pvCheckSummary');
    return entry.bundleType === 'pv' ? t('pvSummary') : t('coreSummary');
  }

  function buildRecommendation(entry, result, selection, decision, config = {}) {
    const { locale } = createLocalization(config);
    if (!isValidRecommendationEntry(entry)) return null;
    const variant = availableVariants(entry.catalog)[0];
    const capacityKwh = Number(entry.capacityKwh);
    const outputW = Number(entry.outputW);
    const bundleType = entry.bundleType;
    const displayTitle = recommendationDisplayTitle(entry, config);
    const presentation = recommendationPresentation(entry, result, selection, decision, config);
    return {
      routeId: entry.routeId,
      productId: entry.catalog.productId,
      variantId: variant.variantId,
      family: entry.family,
      capacityKwh,
      outputW,
      bundleType,
      level: decision.level,
      kicker: presentation.kicker,
      displayTitle,
      summary: recommendationSummary(entry, result, selection, decision, config),
      copy: presentation.copy,
      bundleLabel: presentation.bundleLabel,
      ctaLabel: presentation.ctaLabel,
      url: localizedUrl(variant.url, config.routesRootUrl),
      image: variant.image || entry.catalog.image || '',
      priceMinor: Number(variant.priceMinor),
      ...(config.currencyCode ? { currencyCode: config.currencyCode } : {}),
      priceFormatted: formatCurrencyMinor(variant.priceMinor, locale, config.currencyCode || (config.payback && config.payback.currencyCode) || null),
      reasons: presentation.reasons,
      paybackEligible: true,
      paybackComplete: decision.level === 'direct' && entry.bundleType === 'pv' && result.moduleCount === 4,
    };
  }

  function recommendationDecisionForSelection(result, selection) {
    if (!result || !selection) return null;
    const capacityKwh = capacityClassForConsumption(result.consumptionKwh);
    if (!capacityKwh) return null;

    const requestedOutputW = Number(selection.outputW);
    const minimumTopologyOutputW = selection.plan === 'retrofit'
      ? 0
      : result.moduleCount >= 18
        ? 7200
        : result.moduleCount >= 10
          ? 4800
          : 0;
    const topologyAdjusted = minimumTopologyOutputW > 0 && (!Number.isFinite(requestedOutputW) || requestedOutputW < minimumTopologyOutputW);
    const selectedOutputW = topologyAdjusted ? minimumTopologyOutputW : requestedOutputW;
    const highOutputRoute = selectedOutputW === 4800
      ? { routeId: selection.plan === 'retrofit' ? 'ac_core_duo_10' : '500_pro_duo_10_core', targetCapacityKwh: capacityKwh }
      : selectedOutputW === 7200
        ? { routeId: selection.plan === 'retrofit' ? 'ac_core_trio_15' : '500_pro_trio_15_core', targetCapacityKwh: capacityKwh }
        : null;

    if (highOutputRoute) {
      return {
        ...highOutputRoute,
        level: 'guided',
        reason: topologyAdjusted ? 'module-topology' : 'multi-unit',
        requestedOutputW,
      };
    }

    if (selection.plan === 'retrofit') {
      const shownCapacityKwh = capacityKwh <= 5 ? 5 : 10;
      return {
        routeId: 'ac_core_' + shownCapacityKwh,
        level: 'guided',
        reason: 'retrofit',
        targetCapacityKwh: capacityKwh,
      };
    }

    if (selection.plan === 'unsure') {
      return { routeId: '500_pro_' + capacityKwh + '_core', level: 'guided', reason: 'plan-unsure' };
    }

    if (![800, 2400].includes(selectedOutputW)) {
      return { routeId: '500_pro_' + capacityKwh + '_core', level: 'guided', reason: 'output-unsure' };
    }

    const family = selectedOutputW === 2400 ? '500_pro' : '500';
    if (selection.plan === 'new-pv') {
      if (result.moduleCount === 4 && result.pvWp <= 2500) {
        return { routeId: family + '_' + capacityKwh + '_pv', level: 'direct', reason: 'exact' };
      }
      return { routeId: family + '_' + capacityKwh + '_core', level: 'guided', reason: 'pv-custom' };
    }

    if (selection.plan === 'core') {
      const needsPvCheck = result.moduleCount > 4 || result.pvWp > 2500;
      return {
        routeId: family + '_' + capacityKwh + '_core',
        level: needsPvCheck ? 'guided' : 'direct',
        reason: needsPvCheck ? 'pv-check' : 'exact',
      };
    }

    return null;
  }

  function directRouteForSelection(result, selection) {
    const decision = recommendationDecisionForSelection(result, selection);
    return decision && decision.level === 'direct' ? decision.routeId : '';
  }

  function selectRecommendation(result, selection, config) {
    const decision = recommendationDecisionForSelection(result, selection);
    if (!decision || !Array.isArray(config.recommendations)) return null;
    const entry = config.recommendations.find((candidate) => candidate.routeId === decision.routeId);
    return buildRecommendation(entry, result, selection, decision, config);
  }

  function selectAlternative(recommendation, result, config, selection) {
    if (!recommendation || !selection || !config || !Array.isArray(config.recommendations)) return null;
    const decision = recommendationDecisionForSelection(result, selection);
    if (!decision || decision.level !== 'direct' || recommendation.level !== 'direct' || decision.routeId !== recommendation.routeId) return null;
    const requestedOutputW = Number(selection.outputW);
    const targetCapacityKwh = capacityClassForConsumption(result.consumptionKwh);
    if (recommendation.outputW !== requestedOutputW || recommendation.capacityKwh !== targetCapacityKwh) return null;
    const primaryEntry = config.recommendations.find((entry) => entry.routeId === recommendation.routeId);
    if (!isValidRecommendationEntry(primaryEntry)) return null;
    for (const entry of config.recommendations) {
      if (!isValidRecommendationEntry(entry) || entry.routeId === recommendation.routeId) continue;
      if (entry.family !== recommendation.family || entry.bundleType !== recommendation.bundleType) continue;
      if (Number(entry.outputW) !== requestedOutputW || Number(entry.capacityKwh) !== targetCapacityKwh) continue;
      if (Number(entry.catalog.productId) === Number(primaryEntry.catalog.productId)) continue;
      const alternative = buildRecommendation(entry, result, selection, { ...decision, routeId: entry.routeId }, config);
      if (alternative && alternative.url !== recommendation.url) return alternative;
    }
    return null;
  }

  function getGuidance(result, selection, recommendationMissing = false, config = {}) {
    const { t, formatNumber } = createLocalization(config);
    if (result.consumptionKwh > 6000) {
      return {
        title: t('customTitle'),
        copy: t('highConsumption'),
      };
    }
    const family = Number(selection.outputW) >= 2400 ? 'SunEnergyXT 500 PRO' : 'SunEnergyXT 500';
    if (selection.plan === 'retrofit') {
      if (Number(selection.outputW) === 800) {
        return {
          title: t('check800Title'),
          copy: t('check800Copy'),
        };
      }
      return {
        title: t('existingTitle'),
        copy: t('existingCopy'),
      };
    }
    if (selection.plan === 'unsure') {
      return {
        title: t('seriesTitle'),
        copy: t('seriesCopy'),
      };
    }
    if (selection.outputW === 'unsure') {
      return {
        title: t('outputGuidanceTitle'),
        copy: t('outputGuidance'),
      };
    }
    if (result.moduleCount > 4 || result.pvWp > 2500) {
      const moduleLabel = t('moduleCount', [result.moduleCount]);
      return {
        title: t('checkFamilyModules', [family, moduleLabel]),
        copy: t('moduleGuidance', [moduleLabel, formatNumber(result.pvWp)]),
      };
    }
    if (selection.plan === 'new-pv' && result.moduleCount !== 4) {
      return {
        title: t('configurePv', [family]),
        copy: t('twoModules'),
      };
    }
    if (recommendationMissing) {
      return {
        title: t('missingTitle'),
        copy: t('missingCopy'),
      };
    }
    return {
      title: t('configurationTitle'),
      copy: t('configurationCopy'),
    };
  }

  function calculatePaybackRange(recommendation, annualSavingsEuro, paybackConfig = {}) {
    if (paybackConfig.enabled !== true || !recommendation || recommendation.paybackEligible !== true) return null;
    if (recommendation.currencyCode && recommendation.currencyCode !== 'EUR') return null;
    const priceMinor = finiteNumber(recommendation.priceMinor);
    const annualSavings = finiteNumber(annualSavingsEuro);
    const uncertaintyPercent = clamp(finiteNumber(paybackConfig.uncertaintyPercent) || 20, 10, 30);
    if (priceMinor === null || priceMinor <= 0 || annualSavings === null || annualSavings <= 0) return null;
    const uncertainty = uncertaintyPercent / 100;
    const lowerYears = roundTo((priceMinor / 100) / (annualSavings * (1 + uncertainty)), 0.5);
    const upperYears = roundTo((priceMinor / 100) / (annualSavings * (1 - uncertainty)), 0.5);
    if (!Number.isFinite(lowerYears) || !Number.isFinite(upperYears) || upperYears <= 0) return null;
    return { lowerYears: Math.max(0.5, lowerYears), upperYears: Math.max(0.5, upperYears) };
  }

  function paybackConfigurationKey(recommendation, result, selection) {
    return JSON.stringify([
      recommendation.routeId, String(recommendation.productId), String(recommendation.variantId),
      recommendation.family, recommendation.capacityKwh, recommendation.outputW, recommendation.bundleType,
      selection.plan, result.moduleCount, result.pvWp, result.outputW, result.consumptionKwh,
      result.direction, result.tilt, result.electricityPriceCents,
      result.modelVersion, result.storageEnabled,
    ]);
  }

  function calculateVerifiedPayback(recommendation, result, selection, settings = {}, now = Date.now()) {
    if (!settings || settings.enabled !== true || settings.countryCode !== 'DE' || settings.currencyCode !== 'EUR') return null;
    if (!recommendation || recommendation.level !== 'direct' || !result || !selection) return null;
    if (recommendation.currencyCode && recommendation.currencyCode !== 'EUR') return null;
    if (!['productId', 'variantId'].every(field => /^[1-9]\d*$/.test(String(recommendation[field])))) return null;
    if (!['routeId', 'family'].every(field => typeof recommendation[field] === 'string' && recommendation[field].trim())) return null;
    if (!Number.isFinite(recommendation.capacityKwh) || recommendation.capacityKwh <= 0) return null;
    if (result.modelVersion !== MODEL_VERSION || result.storageEnabled !== true) return null;
    if (!MODULE_COUNTS.includes(result.moduleCount) || result.pvWp !== result.moduleCount * 460) return null;
    if (!OUTPUT_OPTIONS.includes(result.outputW) || Number(selection.outputW) !== result.outputW) return null;
    if (!Number.isInteger(result.consumptionKwh) || result.consumptionKwh < CONSUMPTION_MIN || result.consumptionKwh > CONSUMPTION_MAX || result.consumptionKwh % CONSUMPTION_STEP !== 0) return null;
    if (!DIRECTIONS.includes(result.direction) || !TILTS.includes(result.tilt) || !Number.isFinite(result.electricityPriceCents) || result.electricityPriceCents <= 0) return null;
    if (!['new-pv', 'retrofit'].includes(selection.plan) || recommendation.outputW !== result.outputW) return null;
    if (selection.plan === 'new-pv' && (recommendation.bundleType !== 'pv' || result.moduleCount !== 4)) return null;
    if (!Number.isSafeInteger(recommendation.priceMinor) || recommendation.priceMinor <= 0 || !Number.isFinite(now)) return null;
    const key = paybackConfigurationKey(recommendation, result, selection);
    const cases = Array.isArray(settings.verifiedCases) ? settings.verifiedCases.filter(record => record && record.configurationKey === key) : [];
    if (cases.length !== 1) return null;
    const record = cases[0];
    const scope = selection.plan === 'new-pv' ? 'complete-new-system' : 'incremental-storage';
    const reviewDate = Date.parse(record.reviewedAt);
    const expiryDate = Date.parse(record.validUntil);
    if (record.schemaVersion !== 1 || record.status !== 'approved' || record.scope !== scope) return null;
    if (record.countryCode !== settings.countryCode || record.currencyCode !== settings.currencyCode || record.priceMinor !== recommendation.priceMinor) return null;
    if (!Number.isFinite(reviewDate) || !Number.isFinite(expiryDate) || reviewDate > now || expiryDate <= now || expiryDate <= reviewDate) return null;
    if (record.modelBasis !== 'exact-configuration' || record.technicalVerified !== true || record.costsComplete !== true || record.adverseScenarioReviewed !== true) return null;
    const baselineScope = selection.plan === 'new-pv' ? 'same-household-without-new-system' : 'same-pv-without-added-storage';
    if (record.baselineScope !== baselineScope || record.exportOpportunityCostIncluded !== true) return null;
    if (!Array.isArray(record.sources) || !record.sources.length || !record.sources.every(source => {
      if (typeof source !== 'string' || !/^https:\/\/[^\s]+$/.test(source)) return false;
      try {
        const url = new URL(source);
        return Boolean(url.hostname && !url.username && !url.password);
      } catch (error) {
        return false;
      }
    })) return null;
    if (!['modelAssumptions', 'adverseScenario', 'costBasis'].every(field => typeof record[field] === 'string' && record[field].trim())) return null;
    const additionalCosts = record.additionalCostsMinor;
    const costFields = ['installation', 'electrical', 'requiredAccessories', 'shipping', 'other'];
    if (!additionalCosts || !costFields.every(field => Number.isSafeInteger(additionalCosts[field]) && additionalCosts[field] >= 0)) return null;
    const additionalInvestmentMinor = costFields.reduce((sum, field) => sum + additionalCosts[field], 0);
    const investmentMinor = recommendation.priceMinor + additionalInvestmentMinor;
    if (!Number.isSafeInteger(investmentMinor) || investmentMinor <= 0) return null;
    if (!Array.isArray(record.adverseYears) || record.adverseYears.length !== 3) return null;
    const cashFields = ['baselineImportCostMinor', 'baselineExportRevenueMinor', 'projectImportCostMinor', 'projectExportRevenueMinor', 'additionalOperatingCostMinor'];
    const annualNetMinor = [];
    for (const year of record.adverseYears) {
      if (!year || !cashFields.every(field => Number.isSafeInteger(year[field]) && year[field] >= 0)) return null;
      if (!Number.isSafeInteger(cashFields.reduce((sum, field) => sum + year[field], 0))) return null;
      const net = year.baselineImportCostMinor - year.baselineExportRevenueMinor - year.projectImportCostMinor + year.projectExportRevenueMinor - year.additionalOperatingCostMinor;
      if (!Number.isSafeInteger(net) || net <= 0) return null;
      annualNetMinor.push(net);
    }
    let cumulativeMinor = 0;
    let years = null;
    annualNetMinor.forEach((net, index) => {
      if (years === null && cumulativeMinor + net >= investmentMinor) years = index + (investmentMinor - cumulativeMinor) / net;
      cumulativeMinor += net;
    });
    if (!Number.isSafeInteger(cumulativeMinor) || years === null || years >= 3) return null;
    const displayYears = Math.ceil(years * 10) / 10;
    if (displayYears >= 3) return null;
    return { years, displayYears, investmentMinor, additionalInvestmentMinor, annualNetMinor, scope, validUntilMs: expiryDate, sources: record.sources, modelAssumptions: record.modelAssumptions, adverseScenario: record.adverseScenario, costBasis: record.costBasis };
  }

  function formatVerifiedPayback(payback, config = {}) {
    const { t, locale } = createLocalization(config);
    const years = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(payback.displayYears);
    return t('verifiedYears', [years, payback.displayYears === 1 ? t('year') : t('years')]);
  }

  function formatPaybackRange(range, config = {}) {
    if (!range) return '';
    const { t, locale } = createLocalization(config);
    const formatter = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });
    const lower = formatter.format(range.lowerYears);
    const upper = formatter.format(range.upperYears);
    return range.lowerYears === range.upperYears ? t('paybackSingle', [lower]) : t('paybackRange', [lower, upper]);
  }

  function formatEuroPerKwh(electricityPriceCents, locale = 'de-DE') {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(electricityPriceCents) / 100) + ' €';
  }

  function updateRangeProgress(input) {
    const minimum = Number(input.min);
    const maximum = Number(input.max);
    const value = Number(input.value);
    const progress = maximum === minimum ? 0 : ((value - minimum) / (maximum - minimum)) * 100;
    input.style.setProperty('--dsc-range-progress', progress + '%');
    const step = input.closest('[data-dsc-step]');
    if (!step) return;
    step.querySelectorAll('[data-dsc-range-choice]').forEach((button) => {
      const selected = Number(button.dataset.dscRangeChoice) === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach((node) => {
      node.textContent = value;
    });
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    const configNode = root.querySelector('[data-dsc-config]');
    let config;
    try {
      config = JSON.parse(configNode ? configNode.textContent : '');
    } catch (error) {
      return;
    }
    if (!hasValidModelConfig(config)) return;
    config.locale = (root.ownerDocument && root.ownerDocument.documentElement.lang) || config.locale;
    const { t, language, formatNumber, formatDecimal, formatEuroPerKwh } = createLocalization(config);

    const controller = new AbortController();
    const signal = controller.signal;
    const controls = Array.from(root.querySelectorAll('[data-dsc-control]'));
    const steps = Array.from(root.querySelectorAll('[data-dsc-step]'));
    const planInput = root.querySelector('[data-dsc-plan-range]');
    const systemInput = root.querySelector('[data-dsc-system]');
    const consumptionInput = root.querySelector('[data-dsc-consumption-range]');
    const outputInput = root.querySelector('[data-dsc-output-range]');
    const directionInput = root.querySelector('[data-dsc-direction]');
    const tiltInput = root.querySelector('[data-dsc-tilt]');
    const electricityPriceInput = root.querySelector('[data-dsc-electricity-price]');
    const recommendationCard = root.querySelector('[data-dsc-recommendation]');
    const guidedCard = root.querySelector('[data-dsc-guided]');
    const resultCard = root.querySelector('[data-dsc-result-card]');
    const resultEmpty = root.querySelector('[data-dsc-result-empty]');
    const resultValues = root.querySelector('[data-dsc-result-values]');
    const recommendationStage = root.querySelector('[data-dsc-recommendation-stage]');
    const progressLabel = root.querySelector('[data-dsc-progress-label]');
    const progressBar = root.querySelector('[data-dsc-progress-bar]');
    const advancedDetails = root.querySelector('[data-dsc-advanced]');
    if (!planInput || !systemInput || !consumptionInput || !outputInput || !directionInput || !tiltInput || !recommendationCard || !guidedCard || !resultCard || steps.length !== 4) return;

    let navigationFrame;
    let rangeCommitTimer;
    let navigationSequence = 0;
    let pendingStepIndex = null;
    let resultsRevealed = false;
    let lastCompletedCount = -1;
    let advancedExpansionHandled = false;
    let paybackExpiryTimer;
    const paybackNode = recommendationCard.querySelector('[data-dsc-verified-payback]');

    if (advancedDetails) {
      advancedDetails.querySelector('summary').addEventListener('click', () => {
        advancedExpansionHandled = true;
      }, { signal });
    }

    function collectInput() {
      const consumptionKwh = Number(consumptionInput.value);
      const plan = PLAN_OPTIONS[Number(planInput.value)];
      const outputW = OUTPUT_OPTIONS[Number(outputInput.value)];
      if (!Number.isFinite(consumptionKwh) || consumptionKwh < CONSUMPTION_MIN || consumptionKwh > CONSUMPTION_MAX || (consumptionKwh - CONSUMPTION_MIN) % CONSUMPTION_STEP !== 0) throw new Error('invalid-consumption');
      if (!plan || !outputW) throw new Error('invalid-project-selection');
      return {
        estimate: {
          outputW,
          moduleCount: MODULE_COUNTS[Number(systemInput.value)],
          consumptionKwh,
          direction: DIRECTIONS[Number(directionInput.value)],
          tilt: Number(tiltInput.value),
          storageEnabled: true,
          electricityPriceCents: electricityPriceInput ? Number(electricityPriceInput.value) : config.electricityPriceCents,
        },
        selection: {
          plan,
          outputW: String(outputW),
          consumptionKwh,
        },
      };
    }

    function updateProgress(activeIndex) {
      if (!progressLabel || !progressBar) return;
      const isComplete = resultsRevealed || activeIndex < 0;
      const visibleStep = isComplete ? steps.length : activeIndex + 1;
      progressLabel.textContent = isComplete ? t('selectionComplete') : t('stepProgress', [visibleStep, steps.length]);
      progressBar.style.width = ((visibleStep / steps.length) * 100) + '%';
    }

    function requiredStepsComplete() {
      return steps.slice(0, REQUIRED_STEP_COUNT).every((step) => step.classList.contains('is-complete'));
    }

    function updateResultVisibility() {
      const completedCount = steps.slice(0, REQUIRED_STEP_COUNT).filter((step) => step.classList.contains('is-complete')).length;
      if (resultEmpty) resultEmpty.hidden = resultsRevealed;
      if (resultValues) resultValues.hidden = !resultsRevealed;
      if (recommendationStage) recommendationStage.hidden = !resultsRevealed;
      if (completedCount !== lastCompletedCount) {
        setText(root, '[data-dsc-result-progress]', t('confirmedProgress', [completedCount, REQUIRED_STEP_COUNT]));
        root.querySelectorAll('[data-dsc-result-progress-segment]').forEach((segment, index) => {
          segment.classList.toggle('is-complete', index < completedCount);
        });
        lastCompletedCount = completedCount;
      }
      if (!resultsRevealed) {
        recommendationCard.hidden = true;
        guidedCard.hidden = true;
      }
      return resultsRevealed;
    }

    function updateResultKicker() {
      setText(root, '[data-dsc-result-kicker]', language === 'de' ? String(config.resultKicker || t('resultKicker')) : t('resultKicker'));
    }

    function markStepComplete(step) {
      if (step) step.classList.add('is-complete');
      if (!resultsRevealed && requiredStepsComplete()) resultsRevealed = true;
      updateResultKicker();
    }

    function clearPendingNavigation() {
      navigationSequence += 1;
      pendingStepIndex = null;
      if (navigationFrame) globalScope.cancelAnimationFrame(navigationFrame);
      clearTimeout(rangeCommitTimer);
    }

    function setActiveStep(activeIndex, moveFocus) {
      const activeStep = steps[activeIndex];
      if (moveFocus && activeStep) {
        activeStep.querySelector('[data-dsc-step-toggle]').focus({ preventScroll: true });
      }
      steps.forEach((step, index) => {
        const isOpen = index === activeIndex;
        const toggle = step.querySelector('[data-dsc-step-toggle]');
        const panel = step.querySelector('[data-dsc-step-panel]');
        step.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        panel.setAttribute('aria-hidden', String(!isOpen));
        panel.inert = !isOpen;
      });
      updateProgress(activeIndex);
      if (activeIndex === steps.length - 1 && advancedDetails && !advancedExpansionHandled) {
        advancedDetails.open = true;
        advancedExpansionHandled = true;
      }
    }

    function revealStepIfNeeded(step) {
      if (!step || !globalScope.matchMedia('(max-width: 989px)').matches) return;
      const reducedMotion = globalScope.matchMedia('(prefers-reduced-motion: reduce)').matches;
      globalScope.requestAnimationFrame(() => {
        globalScope.requestAnimationFrame(() => {
          const rect = step.getBoundingClientRect();
          if (rect.top < 76 || rect.bottom > globalScope.innerHeight - 20) {
            step.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          }
        });
      });
    }

    function renderAlternative(recommendation, result, selection) {
      const details = recommendationCard.querySelector('[data-dsc-alternative-details]');
      const alternative = selectAlternative(recommendation, result, config, selection);
      details.hidden = !alternative;
      if (!alternative) {
        details.open = false;
        details.querySelector('[data-dsc-alternative-link]').removeAttribute('href');
        return;
      }
      const image = details.querySelector('[data-dsc-alternative-image]');
      image.hidden = !alternative.image;
      if (alternative.image) image.src = alternative.image;
      else image.removeAttribute('src');
      image.alt = '';
      setText(details, '[data-dsc-alternative-summary]', t('alternative', [formatNumber(alternative.outputW)]));
      setText(details, '[data-dsc-alternative-title]', alternative.displayTitle);
      setText(details, '[data-dsc-alternative-price]', alternative.priceFormatted);
      details.querySelector('[data-dsc-alternative-link]').href = alternative.url;
    }

    function clearVerifiedPayback() {
      clearTimeout(paybackExpiryTimer);
      if (paybackNode) {
        paybackNode.hidden = true;
        paybackNode.querySelector('details').open = false;
        paybackNode.querySelectorAll('[data-dsc-payback-text]').forEach(node => { node.textContent = ''; });
        paybackNode.querySelector('[data-dsc-payback-sources]').replaceChildren();
      }
    }

    function renderRecommendation(result, selection) {
      const recommendation = selectRecommendation(result, selection, config);
      if (!recommendation) {
        recommendationCard.hidden = true;
        guidedCard.hidden = false;
        const routeExpected = Boolean(recommendationDecisionForSelection(result, selection));
        const guidance = getGuidance(result, selection, routeExpected, config);
        setText(guidedCard, '[data-dsc-guided-title]', guidance.title);
        setText(guidedCard, '[data-dsc-guided-copy]', guidance.copy);
        return false;
      }

      const image = recommendationCard.querySelector('[data-dsc-product-image]');
      image.hidden = !recommendation.image;
      if (recommendation.image) image.src = recommendation.image;
      else image.removeAttribute('src');
      image.alt = '';
      setText(recommendationCard, '[data-dsc-product-kicker]', recommendation.kicker);
      setText(recommendationCard, '[data-dsc-product-title]', recommendation.displayTitle);
      const explanation = recommendationCard.querySelector('[data-dsc-product-explanation]');
      const showSummary = Boolean(explanation && recommendation.summary);
      setText(recommendationCard, '[data-dsc-product-copy]', showSummary ? recommendation.summary : recommendation.copy);
      if (explanation) {
        explanation.textContent = showSummary ? recommendation.copy : '';
        explanation.hidden = !showSummary;
      }
      setText(recommendationCard, '[data-dsc-product-price]', recommendation.priceFormatted);
      setText(recommendationCard, '[data-dsc-product-capacity]', t('storageClass', [recommendation.capacityKwh]));
      setText(recommendationCard, '[data-dsc-product-output]', formatNumber(recommendation.outputW) + ' W');
      setText(recommendationCard, '[data-dsc-product-bundle]', recommendation.bundleLabel);
      recommendation.reasons.forEach((reason, index) => setText(recommendationCard, '[data-dsc-reason="' + index + '"]', reason));
      const productLink = recommendationCard.querySelector('[data-dsc-product-link]');
      productLink.href = recommendation.url;
      productLink.textContent = recommendation.ctaLabel;

      const verifiedPayback = language !== 'de' ? null : calculateVerifiedPayback(recommendation, result, selection, {
        ...config.payback,
        countryCode: config.countryCode || (config.payback && config.payback.countryCode),
        currencyCode: config.currencyCode || (config.payback && config.payback.currencyCode),
      });
      if (paybackNode && verifiedPayback) {
        setText(paybackNode, '[data-dsc-payback-years]', formatVerifiedPayback(verifiedPayback, config));
        setText(paybackNode, '[data-dsc-payback-scope]', verifiedPayback.scope === 'complete-new-system' ? t('completeInvestment') : t('storageInvestment'));
        setText(paybackNode, '[data-dsc-payback-investment]', t('investment', [formatCurrencyMinor(verifiedPayback.investmentMinor), formatCurrencyMinor(verifiedPayback.additionalInvestmentMinor)]));
        setText(paybackNode, '[data-dsc-payback-cashflow]', t('cashflow', [verifiedPayback.annualNetMinor.map(formatCurrencyMinor).join(' / ')]));
        setText(paybackNode, '[data-dsc-payback-assumptions]', verifiedPayback.modelAssumptions);
        setText(paybackNode, '[data-dsc-payback-scenario]', verifiedPayback.adverseScenario);
        setText(paybackNode, '[data-dsc-payback-cost-basis]', verifiedPayback.costBasis);
        verifiedPayback.sources.forEach((source, index) => {
          const link = document.createElement('a');
          link.href = source;
          link.textContent = t('source', [index + 1]);
          link.target = '_blank';
          link.rel = 'noopener';
          paybackNode.querySelector('[data-dsc-payback-sources]').append(link);
        });
        paybackNode.hidden = false;
        paybackExpiryTimer = setTimeout(() => render(false), Math.min(2147483647, Math.max(1, verifiedPayback.validUntilMs - Date.now())));
      }

      renderAlternative(recommendation, result, selection);
      recommendationCard.hidden = false;
      guidedCard.hidden = true;
      return true;
    }

    let liveRegionTimer;

    function render(announce) {
      clearVerifiedPayback();
      let collected;
      try {
        collected = collectInput();
      } catch (error) {
        return false;
      }

      [planInput, systemInput, consumptionInput, outputInput, directionInput, tiltInput, electricityPriceInput].filter(Boolean).forEach(updateRangeProgress);
      const moduleCount = collected.estimate.moduleCount;
      const systemConfig = config.systems[String(moduleCount)];
      const pvWp = systemConfig.pvWp;
      const consumptionKwh = collected.selection.consumptionKwh;
      const systemLabel = t('modulePower', [moduleCount, formatNumber(pvWp)]);
      const moduleNote = t('moduleNote');
      const consumptionLabel = t('annualConsumption', [formatNumber(consumptionKwh)]);
      const directionNames = [t('north'), t('northEast'), t('east'), t('southEast'), t('south'), t('southWest'), t('west'), t('northWest')];
      const directionLabel = directionNames[Number(directionInput.value)];
      const outputLabel = formatNumber(collected.selection.outputW) + ' W';
      const topologyNote = collected.selection.plan === 'retrofit' || moduleCount < 10
        ? ''
        : moduleCount < 18
          ? t('duoNote', [moduleCount])
          : t('trioNote', [moduleCount]);
      const planLabels = {
        'new-pv': t('planPv'),
        core: t('planCore'),
        retrofit: t('planRetrofit'),
        unsure: t('planUnsure'),
      };
      const planDescriptions = {
        'new-pv': t('planPvDescription'),
        core: t('planCoreDescription'),
        retrofit: t('planRetrofitDescription'),
        unsure: t('planUnsureDescription'),
      };

      planInput.setAttribute('aria-valuetext', planLabels[collected.selection.plan]);
      systemInput.setAttribute('aria-valuetext', systemLabel);
      consumptionInput.setAttribute('aria-valuetext', consumptionLabel);
      root.querySelectorAll('[data-dsc-consumption-adjust]').forEach((button) => {
        button.disabled = Number(button.dataset.dscConsumptionAdjust) < 0 ? consumptionKwh <= CONSUMPTION_MIN : consumptionKwh >= CONSUMPTION_MAX;
      });
      outputInput.setAttribute('aria-valuetext', outputLabel);
      directionInput.setAttribute('aria-valuetext', directionLabel);
      tiltInput.setAttribute('aria-valuetext', t('degrees', [collected.estimate.tilt]));
      setText(root, '[data-dsc-plan-value]', planLabels[collected.selection.plan]);
      setText(root, '[data-dsc-plan-description]', planDescriptions[collected.selection.plan]);
      setText(root, '[data-dsc-system-value]', systemLabel);
      setText(root, '[data-dsc-module-note]', moduleNote);
      setText(root, '[data-dsc-consumption-value]', consumptionLabel);
      setText(root, '[data-dsc-output-value]', outputLabel);
      const topologyNoteNode = root.querySelector('[data-dsc-topology-note]');
      if (topologyNoteNode) {
        topologyNoteNode.hidden = !topologyNote;
        topologyNoteNode.textContent = topologyNote;
      }
      const directionCodes = { de: DIRECTIONS, en: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'], nl: ['N', 'NO', 'O', 'ZO', 'Z', 'ZW', 'W', 'NW'] };
      setText(root, '[data-dsc-direction-value]', directionCodes[language][Number(directionInput.value)]);
      setText(root, '[data-dsc-tilt-value]', collected.estimate.tilt + '°');
      setText(root, '[data-dsc-step-summary="plan"]', planLabels[collected.selection.plan] || t('notSelected'));
      setText(root, '[data-dsc-step-summary="modules"]', systemLabel);
      setText(root, '[data-dsc-step-summary="consumption"]', consumptionLabel);
      setText(root, '[data-dsc-step-summary="output"]', outputLabel + (Number(outputInput.value) === Number(outputInput.defaultValue) ? t('preset') : ''));
      setText(root, '[data-dsc-continue="modules"]', t('continueModules', [moduleCount]));
      setText(root, '[data-dsc-continue="consumption"]', resultsRevealed ? t('continueOutput') : t('calculateConsumption', [formatNumber(consumptionKwh)]));
      setText(root, '[data-dsc-price-value]', formatNumber(collected.estimate.electricityPriceCents) + ' ct/kWh');
      setText(root, '[data-dsc-price-summary]', formatNumber(collected.estimate.electricityPriceCents) + ' ct/kWh');

      if (!resultsRevealed) {
        updateResultVisibility();
        return true;
      }

      let result;
      try {
        result = calculateEstimate(collected.estimate, config);
      } catch (error) {
        return false;
      }

      setText(root, '[data-dsc-saving]', formatNumber(result.savingsEuro) + ' €');
      const outputIndex = OUTPUT_OPTIONS.indexOf(result.outputW);
      const lowerOutputW = OUTPUT_OPTIONS[Math.max(0, outputIndex - 1)];
      const lowerOutputResult = outputIndex > 0 ? calculateEstimate({ ...collected.estimate, outputW: lowerOutputW }, config) : null;
      const outputEffect = !lowerOutputResult
        ? t('output800')
        : lowerOutputResult.savingsEuro === result.savingsEuro
          ? t('outputUnchanged', [formatNumber(lowerOutputW)])
          : t('outputIncrease', [formatNumber(lowerOutputW), formatNumber(result.savingsEuro - lowerOutputResult.savingsEuro)]);
      setText(root, '[data-dsc-output-effect]', outputEffect);
      setText(root, '[data-dsc-result-output]', t('outputIncluded', [formatNumber(result.outputW)]));
      setText(root, '[data-dsc-monthly-saving]', formatNumber(roundTo(result.savingsEuro / 12, 1)) + ' €');
      setText(root, '[data-dsc-self-used]', formatNumber(result.selfUsedKwh) + ' kWh');
      setText(root, '[data-dsc-generation]', formatNumber(result.generationKwh) + ' kWh');
      setText(root, '[data-dsc-grid-reduction]', formatNumber(result.gridReductionPercent) + ' %');
      setText(root, '[data-dsc-savings-equation]', t('savingsEquation', [formatNumber(result.selfUsedKwh), formatEuroPerKwh(result.electricityPriceCents), formatNumber(result.savingsEuro)]));
      const storageBasis = t('storageReference', [formatDecimal(result.storageReferenceKwh)]);
      setText(root, '[data-dsc-model-basis]', t('modelBasis', [storageBasis]));
      const modelScopeNode = root.querySelector('[data-dsc-model-scope]');
      if (modelScopeNode) {
        modelScopeNode.hidden = false;
        modelScopeNode.textContent = t('modelScope');
      }
      const hasRecommendation = renderRecommendation(result, collected.selection);
      updateResultVisibility();

      if (announce) {
        clearTimeout(liveRegionTimer);
        liveRegionTimer = setTimeout(() => {
          setText(root, '[data-dsc-live]', t('liveUpdate', [formatNumber(result.savingsEuro)]));
        }, 650);
      }

      if (announce) {
        root.dispatchEvent(new CustomEvent('drbo:savings-calculator:change', {
          bubbles: true,
          detail: {
            sectionId: config.sectionId,
            moduleCount: result.moduleCount,
            consumptionKwh: result.consumptionKwh,
            outputW: collected.selection.outputW,
            plan: collected.selection.plan,
            hasRecommendation,
          },
        }));
      }
      return true;
    }

    steps.forEach((step, index) => {
      step.querySelector('[data-dsc-step-toggle]').addEventListener('click', () => {
        clearPendingNavigation();
        const activeIndex = steps.findIndex((candidate) => candidate.classList.contains('is-open'));
        const activeStep = steps[activeIndex];
        if (index === activeIndex + 1 && activeStep && activeIndex < REQUIRED_STEP_COUNT && !activeStep.classList.contains('is-complete')) {
          markStepComplete(activeStep);
          render(true);
        }
        setActiveStep(index, false);
      }, { signal });
    });

    controls.forEach((control) => {
      if (control.type === 'range') {
        control.addEventListener('input', () => {
          clearTimeout(rangeCommitTimer);
          render(false);
        }, { signal });
        control.addEventListener('change', () => render(true), { signal });
      }
    });

    function scheduleStepRangeConfirmation(control) {
      clearTimeout(rangeCommitTimer);
      if (control === consumptionInput) return;
      if (control === outputInput && resultsRevealed) return;
      const step = control.closest('[data-dsc-step]');
      if (resultsRevealed && step && step.classList.contains('is-complete')) return;
      const delay = control === systemInput ? 1200 : 360;
      rangeCommitTimer = globalScope.setTimeout(() => {
        rangeCommitTimer = 0;
        confirmStepRange(control, false);
      }, delay);
    }

    function confirmStepRange(control, moveFocus) {
      const step = control.closest('[data-dsc-step]');
      if (!step || !step.classList.contains('is-open')) return;
      const stepIndex = Number(step.dataset.dscStep);
      if (pendingStepIndex === stepIndex) return;
      clearPendingNavigation();
      const sequence = navigationSequence;
      pendingStepIndex = stepIndex;
      markStepComplete(step);
      render(true);
      if (stepIndex === steps.length - 1) {
        pendingStepIndex = null;
        updateProgress(stepIndex);
        return;
      }
      if (stepIndex < steps.length - 1) {
        if (moveFocus) {
          pendingStepIndex = null;
          setActiveStep(stepIndex + 1, true);
          revealStepIfNeeded(steps[stepIndex + 1]);
        } else {
          navigationFrame = globalScope.requestAnimationFrame(() => {
            if (sequence !== navigationSequence) return;
            pendingStepIndex = null;
            setActiveStep(stepIndex + 1, false);
            revealStepIfNeeded(steps[stepIndex + 1]);
          });
        }
        return;
      }

    }

    root.querySelectorAll('[data-dsc-step-continue]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.closest('[data-dsc-step]');
        const control = step && step.querySelector('[data-dsc-step-range]');
        if (control) confirmStepRange(control, true);
      }, { signal });
    });

    root.querySelectorAll('[data-dsc-step-range]').forEach((control) => {
      if (typeof globalScope.PointerEvent === 'function') {
        let activePointerId = null;
        control.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          clearTimeout(rangeCommitTimer);
          activePointerId = event.pointerId;
          if (typeof control.setPointerCapture !== 'function') return;
          try {
            control.setPointerCapture(event.pointerId);
          } catch {}
        }, { signal });
        control.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (activePointerId === null || activePointerId !== event.pointerId) return;
          activePointerId = null;
          scheduleStepRangeConfirmation(control);
        }, { signal });
        control.addEventListener('pointercancel', () => {
          activePointerId = null;
        }, { signal });
      } else {
        let lastTouchEnd = 0;
        control.addEventListener('touchend', () => {
          lastTouchEnd = Date.now();
          scheduleStepRangeConfirmation(control);
        }, { passive: true, signal });
        control.addEventListener('mouseup', (event) => {
          if (event.button !== 0 || Date.now() - lastTouchEnd < 500) return;
          scheduleStepRangeConfirmation(control);
        }, { signal });
      }
      control.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        confirmStepRange(control, true);
      }, { signal });
    });

    root.querySelectorAll('[data-dsc-range-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.closest('[data-dsc-step]');
        const control = step && step.querySelector('[data-dsc-step-range]');
        const value = Number(button.dataset.dscRangeChoice);
        if (!control || !step.classList.contains('is-open') || !Number.isFinite(value)) return;
        control.value = String(value);
        confirmStepRange(control, false);
      }, { signal });
    });

    root.querySelectorAll('[data-dsc-consumption-adjust]').forEach((button) => {
      button.addEventListener('click', () => {
        clearTimeout(rangeCommitTimer);
        const adjustment = Number(button.dataset.dscConsumptionAdjust);
        if (![-CONSUMPTION_STEP, CONSUMPTION_STEP].includes(adjustment)) return;
        consumptionInput.value = String(clamp(Number(consumptionInput.value) + adjustment, CONSUMPTION_MIN, CONSUMPTION_MAX));
        render(true);
      }, { signal });
    });

    globalScope.addEventListener('pageshow', () => render(false), { signal });
    root.ownerDocument.addEventListener('visibilitychange', () => {
      if (root.ownerDocument.visibilityState === 'visible') render(false);
    }, { signal });

    setActiveStep(0, false);
    updateResultKicker();
    updateResultVisibility();
    if (!render(false)) {
      controller.abort();
      return;
    }
    root.classList.add('is-ready');
    instances.set(root, {
      destroy() {
        clearVerifiedPayback();
        clearTimeout(liveRegionTimer);
        clearPendingNavigation();
        controller.abort();
        instances.delete(root);
      },
    });
  }

  function initWithin(container) {
    if (!container || !container.querySelectorAll) return;
    if (container.matches && container.matches('[data-drbo-savings-calculator]')) init(container);
    container.querySelectorAll('[data-drbo-savings-calculator]').forEach(init);
  }

  function destroyWithin(container) {
    if (!container || !container.querySelectorAll) return;
    const roots = [];
    if (container.matches && container.matches('[data-drbo-savings-calculator]')) roots.push(container);
    container.querySelectorAll('[data-drbo-savings-calculator]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      const instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  const api = Object.freeze({
    calculateEstimate,
    getSpecificYield,
    hasValidModelConfig,
    isValidCatalog,
    capacityClassForConsumption,
    recommendationDecisionForSelection,
    directRouteForSelection,
    selectRecommendation,
    selectAlternative,
    getGuidance,
    calculatePaybackRange,
    calculateVerifiedPayback,
    paybackConfigurationKey,
    formatVerifiedPayback,
    createLocalization,
    localizedUrl,
  });

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  if (!globalScope.document) return;
  globalScope.DRBOSavingsCalculator = api;
  globalScope[browserRegistryKey] = Object.freeze({ instances, initWithin, destroyWithin });

  if (globalScope.document.readyState === 'loading') {
    globalScope.document.addEventListener('DOMContentLoaded', () => initWithin(globalScope.document), { once: true });
  } else {
    initWithin(globalScope.document);
  }

  globalScope.document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  globalScope.document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
